(function ()
{
    'use strict';

    angular
        .module('app.calendar',
            [
                // 3rd Party Dependencies
                'ui.calendar'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
        .state('app.calendar', {
            url      : '/calendar',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/calendar/calendar.html',
                    controller : 'CalendarController as vm'
                }
            },
            bodyClass: 'calendar',
            resolve: {
                Events: function (api, localStorageService) {
                    return api.events.query({'sel_company': localStorageService.get('sel_company')}).$promise;
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/calendar');

    }
})();
(function ()
{
    'use strict';

    angular.module('app.calendar')
        .controller('EventFormDialogController', EventFormDialogController);

    /** @ngInject */
    function EventFormDialogController($mdDialog, dialogData)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.notifications = ['15 minutes before', '30 minutes before', '1 hour before'];

        // Methods
        vm.saveEvent = saveEvent;
        vm.removeEvent = removeEvent;
        vm.closeDialog = closeDialog;

        init();

        //////////

        /**
         * Initialize
         */
        function init()
        {
            // Figure out the title
            switch ( vm.dialogData.type )
            {
                case 'add' :
                    vm.dialogTitle = 'Add Event';
                    break;

                case 'edit' :
                    vm.dialogTitle = 'Add Event';
                    break;

                default:
                    break;
            }

            // Edit
            if ( vm.dialogData.calendarEvent )
            {
                // Clone the calendarEvent object before doing anything
                // to make sure we are not going to brake FullCalendar
                vm.calendarEvent = angular.copy(vm.dialogData.calendarEvent);

                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.calendarEvent.start) )
                {
                    vm.calendarEvent.start = vm.calendarEvent.start.toDate();
                }

                if ( moment.isMoment(vm.calendarEvent.end) )
                {
                    vm.calendarEvent.end = vm.calendarEvent.end.toDate();
                }
            }
            // Add
            else
            {
                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.dialogData.start) )
                {
                    vm.dialogData.start = vm.dialogData.start.toDate();
                }

                if ( moment.isMoment(vm.dialogData.end) )
                {
                    vm.dialogData.end = vm.dialogData.end.toDate();
                }

                vm.calendarEvent = {
                    start        : vm.dialogData.start,
                    end          : vm.dialogData.end,
                    notifications: []
                };
            }
        }

        /**
         * Save the event
         */
        function saveEvent()
        {
            // Convert the javascript date objects back to the moment.js dates
            var dates = {
                start: moment.utc(vm.calendarEvent.start),
                end  : moment.utc(vm.calendarEvent.end)
            };

            var response = {
                type         : vm.dialogData.type,
                calendarEvent: angular.extend({}, vm.calendarEvent, dates)
            };

            $mdDialog.hide(response);
        }

        /**
         * Remove the event
         */
        function removeEvent()
        {
            var response = {
                type         : 'remove',
                calendarEvent: vm.calendarEvent
            };

            $mdDialog.hide(response);
        }

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.calendar')
        .controller('EventDetailDialogController', EventDetailDialogController);

    /** @ngInject */
    function EventDetailDialogController($mdDialog, calendarEvent, showEventFormDialog, event)
    {
        var vm = this;

        // Data
        vm.calendarEvent = calendarEvent;

        // Methods
        vm.editEvent = editEvent;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Edit the calendar event
         *
         * @param calendarEvent
         */
        function editEvent(calendarEvent)
        {
            showEventFormDialog('edit', calendarEvent, false, false, event);
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.users', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        $stateProvider
          .state('app.users', {
                url    : '/users',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pages/users/users.html',
                        controller : 'UsersController as vm'
                    }
                },
                params: {
                    showToastMessage : null,
                    client : null
                }
            });

        $translatePartialLoaderProvider.addPart('app/main/pages/users');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.users')
        .controller('UsersController', UsersController);

    /** @ngInject */
    function UsersController($compile, api, $scope, $mdToast, $state, $translate, $cookies, localStorageService, $mdDialog, $window, DTOptionsBuilder, DTColumnBuilder, CONFIG, $mdSidenav)
    {
        console.log("UsersController");

        var vm = this;
        vm.dtInstance = {};
        vm.topfilter = '';

        vm.permPrefix = "Utilizadores_"
        vm.perms = '';

        vm.profiles = null;
        vm.sel_profile = null;
        vm.sel_profile_id = '';
        
        /*if($state.params.client) {
            vm.sel_client = $state.params.client;
            vm.sel_client_id = $state.params.client.id;
            vm.topfilter = $state.params.client.client;
        }*/

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg) {
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');

            $mdToast.show(toast);
        }

        function updateSearch(e){
            e.stopPropagation();
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function actionsHtml(data, type, full, meta) {
            if(data.allowDelete) {
                return '<div class="buttons" layout="row" layout-align="center center"><md-button ng-show="vm.checkPerm(\'alterar\');" id="edit_btn" class="md-icon-button"><md-icon md-font-icon="icon-pencil-box-outline" ng-click="$mdOpenMenu($event)"></md-icon></md-button><md-button ng-show="vm.checkPerm(\'eliminar\');" class="md-icon-button" id="del_btn"><md-icon md-font-icon="icon-close-circle-outline"></md-icon></md-button></div>';
            } else {
                return '<div class="buttons" layout="row" layout-align="center center"><md-button ng-show="vm.checkPerm(\'alterar\');" id="edit_btn" class="md-icon-button"><md-icon md-font-icon="icon-pencil-box-outline" ng-click="$mdOpenMenu($event)"></md-icon></md-button></div>';
            }
        }

        function createdRow(row, data, dataIndex) {
            $compile(angular.element(row).contents())($scope);
        }

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrlJson + 'json/users.php',
                type: 'POST',
                "dataSrc": function(json) {
                    vm.perms = json.perms;
                    console.log(json);
                    return json.data;
                },
                "data": function(d){
                    d.search['value'] = vm.seach_keyword;
                    d.profile_id = vm.sel_profile_id;
                    d.sel_company = localStorageService.get('sel_company');
                    d.profile = localStorageService.get('profile');
                }
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('scrollY', 'auto')
            .withOption('bLengthChange', true)
            .withOption('responsive',true)
            .withPaginationType('full_numbers')
            .withOption('createdRow', createdRow)
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {

                $('td:eq(0), td:eq(1), td:eq(2), #edit_btn', nRow).css('cursor', 'pointer');
                $('td:eq(0), td:eq(1), td:eq(2), #edit_btn', nRow).unbind('click');
                $('td:eq(0), td:eq(1), td:eq(2), #edit_btn', nRow).bind('click', function() {
                    $scope.$apply(function() {
                        vm.gotoDetail(aData.id);
                        return nRow;
                    });
                });
                $('#del_btn', nRow).unbind('click');
                $('#del_btn', nRow).bind('click', function() {
                    $scope.$apply(function() {
                        vm.deleteConfirm(aData);
                        return nRow;
                    });
                });
                $('#lines_btn', nRow).unbind('click');
                $('#lines_btn', nRow).bind('click', function() {
                    $scope.$apply(function() {
                        vm.gotoEquipments(aData);
                        return nRow;
                    });
                });
            })
            //.withOption('order', [7, 'desc'])
            .withOption('initComplete', function(){
                var api = this.api(),
                    searchBox = angular.element('body').find('#e-commerce-products-search');

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;

                if ( searchBox.length > 0 ) {
                    searchBox.on('keyup', function (event) {
                        vm.seach_keyword = event.target.value;
                        vm.dtInstance.reloadData();
                    });
                }
                $('th').css('background-color', '#2d323e');
                $('th').css('color', '#fff');
                $('th:eq(3)').css('text-align', 'center');
                $('th:last-child').css('text-align', 'center');
            })
            .withLanguage({
                "sInfo": $translate.instant('USERS.TABLE_INFO'),
                "paginate": {
                    "first": $translate.instant('USERS.TABLE_BUT_FIRST'),
                    "last": $translate.instant('USERS.TABLE_BUT_LAST'),
                    "next": $translate.instant('USERS.TABLE_BUT_NEXT'),
                    "previous": $translate.instant('USERS.TABLE_BUT_PREVIOUS')
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('company').withTitle($translate.instant('USER.COMPANY')),
            DTColumnBuilder.newColumn('name').withTitle($translate.instant('USER.USERNAME')),
            DTColumnBuilder.newColumn('profile').withTitle($translate.instant('USER.PROFILE')),
            DTColumnBuilder.newColumn(null).withTitle($translate.instant('USER.TABLE_COL_ACTIONS')).notSortable()
                .renderWith(actionsHtml).withOption('width', '100px'),
            DTColumnBuilder.newColumn('id').notVisible()
        ];

        vm.filterProfiles = filterProfiles;
        vm.loadProfiles = loadProfiles;

        vm.checkPerm = checkPerm;

        function checkPerm(perm) {
            if(vm.perms.indexOf(vm.permPrefix+perm)>-1) {
                return true;
            } else {
                return false;
            }
        }

        /* FILTERS */
        function filterProfiles() {
            if(vm.sel_profile) {
                vm.sel_profile_id = vm.sel_profile.id;
                vm.dtInstance.reloadData();
            }
        }

        /* LOADS */
        function loadProfiles() {
            var promisse = api.profiles.get().$promise;
            promisse.then(function (collection) {
                vm.profiles = collection.records;
            });
        }

        // Methods
        vm.gotoDetail       = gotoDetail;
        vm.deleteConfirm    = deleteConfirm;
        vm.toggleSidenav    = toggleSidenav;
        vm.updateSearch     = updateSearch;
        vm.haveFilters      = haveFilters;
        vm.clearFilters     = clearFilters;
        vm.gotoEquipments   = gotoEquipments;

        function gotoEquipments(src)
        {
            $state.go('app.equipments', {local: src});
        }

        function haveFilters()
        {
            if(vm.sel_profile_id != '')
                return true;
            else
                return false;
        }

        function clearFilters()
        {
            vm.sel_profile_id = '';
            vm.sel_profile = null;
            vm.dtInstance.reloadData();
        }

        function gotoDetail(id)
        {
            $state.go('app.user', {id: id});
        }

        function deleteConfirm(record, ev)
        {
            var confirm = $mdDialog.confirm()
                .title( $translate.instant('USERS.DELETE_QUESTION') )
                .htmlContent('<b>' + record.name + '</b>' + $translate.instant('USERS.DELETE_SENTENCE'))
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok($translate.instant('USERS.DELETE_YES'))
                .cancel($translate.instant('USERS.DELETE_NO'));

            $mdDialog.show(confirm).then(function ()
            {
                console.log(record.id);
                api.users.delete({ id: record.id }).$promise.then(function (record) {
                    vm.totalRecords = vm.totalRecords - 1;
                    vm.dtInstance.reloadData();
                    showToast($translate.instant('USERS.DELETE_MSG'));
                });
            }, function ()
            {

            });
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.user', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.user', {
              url      : '/user/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/user/user.html',
                      controller : 'UserController as vm'
                  }
              },
              resolve  : {
                  User: function (api, $stateParams, localStorageService)
                  {
                      return api.users.get({ id: $stateParams.id, profile: localStorageService.get('profile') }).$promise;
                  }
              },
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/user');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.user')
        .controller('UserController', UserController);

    function UserController($scope, $document, $state, User, api, $window, $translate)
    {
        console.log("UserController");
        var vm = this;

        vm.record = User.record ? User.record : null;
        vm.recordLabel = User.record ? (User.record.DisplayName ? User.record.DisplayName : $translate.instant('USER.NEW_RECORD')) : $translate.instant('USER.NEW_RECORD');

        vm.perms = User.perms;
        vm.permPrefix = "Utilizadores_";

        vm.profiles = User.profiles;
        vm.companys = User.companys;

        vm.gotoList = gotoList;
        vm.save = save;
        vm.checkPerm = checkPerm;

        function checkPerm(perm) {
            if(vm.perms.indexOf(vm.permPrefix+perm)>-1) {
                return true;
            } else {
                return false;
            }
        }

        function gotoList()
        {
            $state.go('app.users');
        }

        function save(record)
        {
            var msg = '';
            api.users.save({ record: record }).$promise.then(function (result) {
                if(record.id > 0)
                    msg = $translate.instant('USER.SAVE_UPDATE');
                else
                    msg = $translate.instant('USER.SAVE_NEW');

                $state.go('app.users', { showToastMessage: msg });
            });
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.report', ['ngFileUpload'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.report', {
              url      : '/report/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/report/report.html',
                      controller : 'ReportController as vm'
                  }
              },
              resolve  : {
                  Report: function (api, $stateParams, localStorageService)
                  {
                      return api.reports.get({ id: $stateParams.id, sel_company: localStorageService.get('sel_company') }).$promise;
                  }
              },
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/report');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.report')
        .controller('ReportController', ReportController);

    function ReportController($mdDialog, $scope, $document, $state, Report, api, $window, $translate, $mdToast, localStorageService, Upload, CONFIG)
    {
        console.log("ReportController");

        var vm = this;

        console.log(Report);

        vm.recordLabel = "Relatório do pedido: " +Report.pedido ;
        vm.perguntas = Report.perguntas;
        vm.respostas = Report.respostas;
        vm.report_status = Report.doc.DocumentStatus;
        vm.estado = Report.doc.DocumentStatus;
        vm.id = Report.pedido;
        vm.images = Report.images;
        vm.report_user_id = Report.user_id ? Report.user_id : 0;
        vm.uploadpercentagem = 100;
        vm.desc = "";
        vm.user_id = localStorageService.get('user_id');

        vm.gotoList = gotoList;
        vm.getResposta = getResposta;
        vm.getRespostaID = getRespostaID;
        vm.save = save;
        vm.showPhoto = showPhoto;
        vm.selectedImage;
        vm.checkReason = checkReason;
        vm.compare = compare;
        vm.save_aprovar = save_aprovar;
        vm.deletePhoto = deletePhoto;
        vm.delete_report = delete_report;

        vm.ngFlowOptions = {
            // You can configure the ngFlow from here
            /*target                   : 'api/media/image',
             chunkSize                : 15 * 1024 * 1024,
             maxChunkRetries          : 1,
             simultaneousUploads      : 1,
             testChunks               : false,
             progressCallbacksInterval: 1000*/
        };
        vm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };
        vm.dropping = false;
        vm.uploadFiles = uploadFiles;

        vm.profile = localStorageService.get('profile');

        vm.submitted = false;

        if(vm.respostas) {
            vm.record = {
                'state' : 'Execução'
            };
            angular.forEach(vm.perguntas, function(value, key){
                if(value.DataType == "TEXTBOX") {
                    var r = ""; var rid = "";
                    angular.forEach(vm.respostas, function(valuen, keyn){
                        if(value.Description == valuen.Question) {
                            r = valuen.Answer;
                            rid = valuen.AnswerID;
                        }
                    });
                    vm.record[rid] = r;
                }

                angular.forEach(vm.respostas, function(valuen, keyn){
                    if(valuen.Reason != '') {
                        vm.record['reason_'+valuen.AnswerID] = valuen.Reason;
                    }
                });
            });
        } 

        function delete_report(src,ev) {
            console.log(src);
            var confirm = $mdDialog.confirm()
                .title( $translate.instant('REPORT.DELETE_QUESTION') )
                .htmlContent('<b>' + Report.pedido + '</b>' + $translate.instant('REPORT.DELETE_SENTENCE'))
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok($translate.instant('REPORT.DELETE_YES'))
                .cancel($translate.instant('REPORT.DELETE_NO'));

            $mdDialog.show(confirm).then(function ()
            {
                api.reports.delete({ id: Report.pedido.replace('/','_') }).$promise.then(function (record) {
                    showToast($translate.instant('ORDERS.DELETE_MSG'));
                    $state.go('app.orders');
                });
            }, function ()
            {

            });
        }

        function showToast(msg) {
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');

            $mdToast.show(toast);
        }

        function deletePhoto(photoId) {
            api.photos.delete({ id: photoId }).$promise.then(function (result) {
                var index = 0;
                angular.forEach(vm.images, function(value, key){
                    if(value.PhotoID == photoId) {
                        vm.images.splice(index, 1);
                    }
                    index++;
                });
            });
        }

        function compare(sr1, sr2) {
            return angular.equals(sr1,sr2);
        }

        function checkReason(pergunta) {
            //console.log('aaa', pergunta);
        }

        function uploadFiles (file, errFiles) {
            console.log('upload: ' + CONFIG.photosBaseUrlJson);
            console.log({file: file, CompanyID: localStorageService.get('sel_company'), DocumentID: Report.pedido, Description: vm.desc})
            Upload.upload({
                url: CONFIG.photosBaseUrlJson + 'Photos',
                data: {file: file, CompanyID: localStorageService.get('sel_company'), DocumentID: Report.pedido, Description: vm.desc}
            }).then(function (resp) {
                console.log(resp);
                if(resp.data.status != 'ERROR') {
                    vm.images.push({Description: vm.desc, type: 'image', Photo: resp.data.status});
                    vm.desc = '';
                }
            }, function (resp) {
                console.log('Error status: ' + resp.status);
            }, function (evt) {
                vm.uploadpercentagem = parseInt(100.0 * evt.loaded / evt.total);
            });
        }

        function showPhoto(ev, image) {
            vm.selectedImage = image;
            $mdDialog.show({
                controller: PhotoController,
                templateUrl: 'app/main/pages/report/dialog/photo.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                hasBackdrop: true,
                selectedOption: 'test here',
                fullscreen: false // Only for -xs, -sm breakpoints.
            })
            .then(function(answer) {
                $scope.status = 'You said the information was "' + answer + '".';
            }, function() {
                $scope.status = 'You cancelled the dialog.';
            });

        }

        function PhotoController($scope, $mdDialog, $filter, api) {
            $scope.imagem = vm.selectedImage;

            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
        }

        function getRespostaID(src) {
            var r = "";
            if(vm.respostas && vm.respostas.length > 0) {
                angular.forEach(vm.respostas, function(value, key){
                    if(value.Question == src) 
                        r = value.AnswerID;
                });
            } else {
                angular.forEach(vm.perguntas, function(value, key){
                    if(value.Description == src) 
                        r = value.QuestionID;
                });
            }
            return r;
        }

        function getResposta(src) {
            if(vm.respostas) {
                var r = "";
                angular.forEach(vm.respostas, function(value, key){
                    if(value.Question == src) 
                        r = value.Answer;
                });
                return r;
            } else {
                return -1;
            }
        }

        function gotoList()
        {
            $state.go('app.orders');
        }

        function save_aprovar(record)
        {
            record.state = 'aproved';
            save(record);
        }

        function save(record)
        {
            var msg = '';
            if(record.state == 'aproved') {
            } else {
                if(vm.respostas && vm.respostas.length > 0) {
                    record.state = 'edit';
                } else {
                    record.state = 'normal';
                }
            }

            record.user_id = localStorageService.get('user_id');
            record.CompanyID = localStorageService.get('sel_company');
            record.DocId = Report.pedido;

            console.log(record);

            api.reports.save({ record: record }).$promise.then(function (result) {
                if(record.id > 0)
                    msg = $translate.instant('REPORT.UPDATE_MSG');
                else
                    msg = $translate.instant('REPORT.INSERT_MSG');

                console.log(result);

                $state.go('app.orders', { showToastMessage: msg });
          });
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.orders', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.orders', {
                url    : '/orders',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pages/orders/orders.html',
                        controller : 'OrdersController as vm'
                    }
                },
                params: {
                    showToastMessage : null,
                    event : null
                }
            });

        $translatePartialLoaderProvider.addPart('app/main/pages/orders');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.orders')
        .controller('OrdersController', OrdersController);

    /** @ngInject */
    function OrdersController($compile, api, $scope, $rootScope, $mdToast, $state, $translate, $cookies, localStorageService, $mdDialog, $window, DTOptionsBuilder, DTColumnBuilder, CONFIG, $mdSidenav)
    {
        console.log("OrdersController");

        var vm = this;
        vm.dtInstance = {};
        vm.topfilter = '';
        vm.profile = localStorageService.get('profile');
        vm.user_id = localStorageService.get('user_id');

        vm.company_back = '';

        vm.routes = null;

        vm.events = null;
        vm.sel_event = null;
        vm.sel_event_id = null;

        vm.states = null;
        vm.sel_state = null;
        vm.sel_state_id = null;
        
        if($state.params.event) {
            vm.sel_event = $state.params.event;
            vm.sel_event_id = $state.params.event.eventId;
            vm.topfilter = $state.params.event.title;

            if(vm.sel_event.EventCompany != '' && vm.sel_event.EventCompany != localStorageService.get('sel_company') && typeof vm.sel_event.EventCompany != 'undefined') {
                localStorageService.set('sel_company', vm.sel_event.EventCompany);

                vm.company_back = vm.sel_event.EventCompany;
                $state.reload();
            }
        }

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg) {
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');

            $mdToast.show(toast);
        }

        function updateSearch(e){
            e.stopPropagation();
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function statusHtml(data, type, full, meta) {
            var orderStatus = vm.getOrderStatus(data);
            return '<span class="status ' + orderStatus.color + '">' + orderStatus.name + '</span>';
        }

        function eventHtml(data, type, full, meta) {
            return '<span>'+data+'</span>';
        }

        function actionsHtml(data, type, full, meta) {
            var report = '';
            var ico_delete = '';

            if(vm.profile == "ADMIN") {
                ico_delete = '<md-button class="md-icon-button" id="del_btn"><md-icon md-font-icon="icon-close-circle-outline"></md-icon></md-button>';
            } else {
                if(vm.user_id == data.UserID) {
                    ico_delete = '<md-button class="md-icon-button" id="del_btn"><md-icon md-font-icon="icon-close-circle-outline"></md-icon></md-button>';
                }
            }

            if(data.hasReport == true) {
                if(vm.profile == "ADMIN") {
                    report = '<md-button id="report_btn" class="md-icon-button"><md-tooltip md-direction="left">Ver relatorio</md-tooltip><md-icon md-font-icon="icon-document" ng-click="$mdOpenMenu($event)"></md-icon></md-button>';
                } else {
                    if(vm.profile != "ADMIN" && data.user_id != vm.user_id) {
                        report = '';
                    } else {
                        report = '<md-button id="report_btn" class="md-icon-button"><md-tooltip md-direction="left">Ver relatorio</md-tooltip><md-icon md-font-icon="icon-document" ng-click="$mdOpenMenu($event)"></md-icon></md-button>';
                    }
                }
            }

            if(vm.profile == "CLIENT") {
                if(data.status == "Registado") {
                    return '<div class="buttons" layout="row" layout-align="end center">'+report+'<md-button id="edit_btn" class="md-icon-button"><md-icon md-font-icon="icon-pencil-box-outline" ng-click="$mdOpenMenu($event)"></md-icon></md-button>'+ico_delete+'</div>';
                } else {
                    return '<div class="buttons" layout="row" layout-align="end center">'+report+ico_delete+'</div>';
                }
            } else {
                if(vm.profile == "ADMIN") {
                    if(report == '') {
                        if(data.status == "Execução" && data.DocSerie == "PI") {
                            return '<div class="buttons" layout="row" layout-align="end center">'+report+'<md-button id="lines_btn" class="md-icon-button"><md-tooltip md-direction="keft">Inserir Relatório</md-tooltip><md-icon md-font-icon="icon-file-outline" ng-click="$mdOpenMenu($event)"></md-icon></md-button><md-button id="edit_btn" class="md-icon-button"><md-icon md-font-icon="icon-pencil-box-outline" ng-click="$mdOpenMenu($event)"></md-icon></md-button>'+ico_delete+'</div>';
                        } else {
                            return '<div class="buttons" layout="row" layout-align="end center">'+report+'<md-button id="edit_btn" class="md-icon-button"><md-icon md-font-icon="icon-pencil-box-outline" ng-click="$mdOpenMenu($event)"></md-icon></md-button>'+ico_delete+'</div>';
                        }
                    } else {
                        return '<div class="buttons" layout="row" layout-align="end center">'+report+'<md-button id="edit_btn" class="md-icon-button"><md-icon md-font-icon="icon-pencil-box-outline" ng-click="$mdOpenMenu($event)"></md-icon></md-button>'+ico_delete+'</div>';
                    }
                } else {
                    if(data.status == "Execução" && data.DocSerie == "PI" && (vm.profile == "ADMIN" || vm.profile == "OPERATOR")) {
                        return '<div class="buttons" layout="row" layout-align="end center">'+report+'<md-button id="lines_btn" class="md-icon-button"><md-tooltip md-direction="keft">Inserir Relatório</md-tooltip><md-icon md-font-icon="icon-file-outline" ng-click="$mdOpenMenu($event)"></md-icon></md-button><md-button id="edit_btn" class="md-icon-button"><md-icon md-font-icon="icon-pencil-box-outline" ng-click="$mdOpenMenu($event)"></md-icon></md-button>'+ico_delete+'</div>';
                    } else {
                        if(data.status == "Atualização") {
                            if(vm.profile == "ADMIN") {
                                return '<div class="buttons" layout="row" layout-align="end center">'+report+'<md-button id="lines_ap_btn" class="md-icon-button"><md-tooltip md-direction="keft">Aprovar Relatório</md-tooltip><md-icon md-font-icon="icon-file-document" ng-click="$mdOpenMenu($event)"></md-icon></md-button>'+ico_delete+'</div>';
                            } else if(vm.profile == "OPERATOR") {
                                return '<div class="buttons" layout="row" layout-align="end center">'+report+'<md-button id="edit_btn" class="md-icon-button"><md-icon md-font-icon="icon-pencil-box-outline" ng-click="$mdOpenMenu($event)"></md-icon></md-button>'+ico_delete+'</div>';
                            } else {
                                return '<div class="buttons" layout="row" layout-align="end center">'+report+ico_delete+'</div>';
                            }
                        } else {
                            return '<div class="buttons" layout="row" layout-align="end center">'+report+'<md-button id="edit_btn" class="md-icon-button"><md-icon md-font-icon="icon-pencil-box-outline" ng-click="$mdOpenMenu($event)"></md-icon></md-button>'+ico_delete+'</div>';
                        }
                    }
                }
            }
        }

        function documentsHtml(data, type, full, meta) {
            var r = '';
            if(data.sel_docs.length > 0) {
                for(var i=0 ; i<data.sel_docs.length ; i++) {
                    r += '<md-button ng-href="http://limpalisboa.pt/api_sgeq/pdfs/'+data.sel_docs[i].talao_pdf+'" target="_blank" class="md-fab md-mini md-primary bg_red" >'
                        + '<md-tooltip md-direction="bottom">' + data.sel_docs[i].data_fim
                        + '</md-tooltip>'
                        + 'T' + data.sel_docs[i].id
                        + '</md-button>';
                }

                return r;
            } else {
                return '';
            }
        }

        function routesHtml(data, type, full, meta) {
            return '<md-select id="select_'+data.id+'" multiple placeholder="Escolha a rota" ng-change="vm.selectRoute('+data.id+')" ng-model="route_'+data.id+'" md-on-open="vm.loadRoutes('+data.id+')" style="min-width: 200px;"><md-option ng-value="route" ng-repeat="route in vm.routes">{{route.route}}</md-option></md-select>';
        }

        function createdRow(row, data, dataIndex) {
            $compile(angular.element(row).contents())($scope);
        }

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrlJson + 'json/orders.php',
                type: 'POST',
                "dataSrc": function(json) {
                    console.log("dataSrc:")
                    console.log(json);
                    return json.data;
                },
                "data": function(d){
                    d.search['value'] = vm.seach_keyword;
                    d.event_id = vm.sel_event_id;
                    d.state_id = vm.sel_state_id;
                    d.sel_company = localStorageService.get('sel_company');
                    d.user_id = vm.user_id; /* CQR - 02-06-2020 */
                    d.profile = vm.profile; /* CQR - 02-06-2020 */
                }
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('scrollY', 'auto')
            .withOption('bLengthChange', true)
            .withOption('responsive',true)
            .withPaginationType('full_numbers')
            .withOption('createdRow', createdRow)
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {

                $('td:eq(0), td:eq(1), td:eq(2), #edit_btn', nRow).css('cursor', 'pointer');
                $('td:eq(0), td:eq(1), td:eq(2), #edit_btn', nRow).unbind('click');
                $('td:eq(0), td:eq(1), td:eq(2), #edit_btn', nRow).bind('click', function() {
                    $scope.$apply(function() {
                        vm.gotoDetail(aData.docid);
                        return nRow;
                    });
                });
                $('#report_btn', nRow).unbind('click');
                $('#report_btn', nRow).bind('click', function() {
                    $scope.$apply(function() {
                        vm.gotoReport(aData);
                        return nRow;
                    });
                });
                $('#del_btn', nRow).unbind('click');
                $('#del_btn', nRow).bind('click', function() {
                    $scope.$apply(function() {
                        vm.deleteConfirm(aData);
                        return nRow;
                    });
                });
                $('#lines_btn', nRow).unbind('click');
                $('#lines_btn', nRow).bind('click', function() {
                    $scope.$apply(function() {
                        vm.gotoReport(aData);
                        return nRow;
                    });
                });
                $('#lines_ap_btn', nRow).unbind('click');
                $('#lines_ap_btn', nRow).bind('click', function() {
                    $scope.$apply(function() {
                        vm.gotoAproveReport(aData);
                        return nRow;
                    });
                });
            })
            //.withOption('order', [7, 'desc'])
            .withOption('initComplete', function(){
                var api = this.api(),
                    searchBox = angular.element('body').find('#e-commerce-products-search');

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;

                if ( searchBox.length > 0 ) {
                    searchBox.on('keyup', function (event) {
                        vm.seach_keyword = event.target.value;
                        vm.dtInstance.reloadData();
                    });
                }
                $('th').css('background-color', '#2d323e');
                $('th').css('color', '#fff');
                $('th:eq(3)').css('text-align', 'center');
                $('th:last-child').css('text-align', 'center');
            })
            .withLanguage({
                "sInfo": $translate.instant('ORDERS.TABLE_INFO'),
                "paginate": {
                    "first": $translate.instant('ORDERS.TABLE_BUT_FIRST'),
                    "last": $translate.instant('ORDERS.TABLE_BUT_LAST'),
                    "next": $translate.instant('ORDERS.TABLE_BUT_NEXT'),
                    "previous": $translate.instant('ORDERS.TABLE_BUT_PREVIOUS')
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('docid').withTitle('DocId'),
            DTColumnBuilder.newColumn('data').withTitle('Data do Pedido'),
            DTColumnBuilder.newColumn('tipo').withTitle('Tipo'),
            DTColumnBuilder.newColumn('status').withTitle('Estado').renderWith(statusHtml),
            DTColumnBuilder.newColumn('evento').withTitle('Evento').renderWith(eventHtml),
            DTColumnBuilder.newColumn('obs').withTitle('Ocorrências'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').notSortable()
                .renderWith(actionsHtml).withOption('width', '100px'),
            DTColumnBuilder.newColumn('docid').notVisible()
        ];

        vm.filterEvents = filterEvents;
        vm.loadEvents = loadEvents;
        vm.filterStates = filterStates;
        vm.loadStates = loadStates;
        vm.openReport = openReport;

        function openReport(id) { 
            /* CQR - 08/11/2019 - */          
            if(!vm.sel_event || (vm.sel_event.IsActive==0)) {
                /* OLD - $state.go('app.events'); */
                vm.gotoDetail(0);
            } else {
                vm.gotoDetail(id);
            } 
        }

        /* FILTERS */
        function filterEvents() {
            if(vm.sel_event) {
                vm.sel_event_id = vm.sel_event.id;
                vm.dtInstance.reloadData();
            }
        }

        function filterStates() {
            if(vm.sel_state) {
                vm.sel_state_id = vm.sel_state.DocumentStatus;
                vm.dtInstance.reloadData();
            }
        }

        /* LOADS */
        function loadEvents() {
            var promisse = api.events.get({'sel_company': localStorageService.get('sel_company')}).$promise;
            promisse.then(function (collection) {
                vm.events = collection.records;
            });
        }

        function loadStates() {
            var promisse = api.documentstates.get({'sel_company': localStorageService.get('sel_company')}).$promise;
            promisse.then(function (collection) {
                vm.states = collection.records;
            });
        }

        // Methods
        vm.gotoDetail       = gotoDetail;
        vm.deleteConfirm    = deleteConfirm;
        vm.toggleSidenav    = toggleSidenav;
        vm.updateSearch     = updateSearch;
        vm.haveFilters      = haveFilters;
        vm.clearFilters     = clearFilters;
        vm.gotoReport       = gotoReport;
        vm.getOrderStatus   = getOrderStatus;
        vm.gotoAproveReport = gotoAproveReport;

        function getOrderStatus(src) {
            var r;

            if(src == "Execução") {
                r = {color: 'md-orange-500-bg', name: src};
            } else {
                if(src == "Atualização") {
                    r = {color: 'md-green-800-bg', name: src};
                } else {
                    if(src == "Executado") {
                        r = {color: 'md-light-green-200-bg', name: src};
                    } else {
                        r = {color: 'md-blue-500-bg', name: src};
                    }
                }
            }
            return r;
        }

        function gotoAproveReport(src) {
            $state.go('app.report', {id: src.docid.replace('/','_')});
        }

        function gotoReport(src)
        {
            $state.go('app.report', {id: src.docid.replace('/','_')});
        }

        function haveFilters()
        {
            if(vm.sel_event_id > 0 || vm.sel_state_id != '')
                return true;
            else
                return false;
        }

        function clearFilters()
        {
            vm.sel_event_id = null;
            vm.sel_event = null;
            vm.sel_state_id = null;
            vm.sel_state = null;
            vm.dtInstance.reloadData();
        }

        function gotoDetail(id)
        {
            $state.go('app.order', {id: id, event: vm.sel_event});
        }

        function deleteConfirm(record, ev)
        {
            var confirm = $mdDialog.confirm()
                .title( $translate.instant('ORDERS.DELETE_QUESTION') )
                .htmlContent('<b>' + record.docid + '</b>' + $translate.instant('ORDERS.DELETE_SENTENCE'))
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok($translate.instant('ORDERS.DELETE_YES'))
                .cancel($translate.instant('ORDERS.DELETE_NO'));

            $mdDialog.show(confirm).then(function ()
            {
                api.orders.delete({ id: record.docid.replace('/','_') }).$promise.then(function (record) {
                    console.log(record);
                    vm.totalRecords = vm.totalRecords - 1;
                    vm.dtInstance.reloadData();
                    showToast($translate.instant('ORDERS.DELETE_MSG'));
                });
            }, function ()
            {

            });
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.order', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.order', {
              url      : '/order/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/order/order.html',
                      controller : 'OrderController as vm'
                  }
              },
              resolve  : {
                  Order: function (api, $stateParams, localStorageService)
                  {
                      return api.orders.get({ id: $stateParams.id.replace('/','_'), sel_company: localStorageService.get('sel_company'), from: 'pedidos' }).$promise;
                  }
              },
                params: {
                    event : null,
                },
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/order');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.order')
        .controller('OrderController', OrderController);

    function OrderController($q,$compile, $mdToast, $scope, $document, $state, Order, api, $window, $translate, $mdDialog, DTOptionsBuilder, DTColumnBuilder, CONFIG, localStorageService)
    {
        console.log("OrderController", Order);

        var vm = this;
        vm.dtInstance = {};
        vm.products = [];
        vm.lines = [];
        vm.locations = Order.locations;
        vm.record = null;
        vm.countrys = Order.countrys;
        vm.profile = localStorageService.get('profile');
        vm.s_implementacao = false;
        vm.s_entrega = false;
        vm.s_levantamento = false;
        vm.lockswitch = false;
        vm.lockinsertlocal = false;
        vm.updateSearch = updateSearch;
        vm.loading = false; /* CQR - 19/01/2021 - Loading no Botão Gravar */

        vm.sel_event = null;
        
        if($state.params.event) {
            vm.sel_event = $state.params.event;
        }else{ /* CQR - 08/11/2019 - Se não existir evento, vai buscar o 1º que já exista */
            vm.sel_event = {};
            vm.sel_event.id = Order.event_id;
            vm.sel_event.eventId = Order.event_id;
        }

        console.log("vm.sel_event:");
        console.log(vm.sel_event);

if($state.params.company_back) {
console.log('=>' + $state.params.company_back);
}

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>');

        vm.dtColumns = [
            DTColumnBuilder.newColumn('Codigo').withTitle('Cod'),
            DTColumnBuilder.newColumn('Description').withTitle('Artigo'),
            DTColumnBuilder.newColumn('qtd').withTitle('Qtd'),
            DTColumnBuilder.newColumn('sn').withTitle('S/N'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').notSortable()
                .renderWith(actionsHtml).withOption('width', '100px'),
            DTColumnBuilder.newColumn('cod').notVisible()
        ];

        function createdRow(row, data, dataIndex) {
            $compile(angular.element(row).contents())($scope);
        }

        function actionsHtml(data, type, full, meta) {
            return '<div class="buttons" layout="row" layout-align="center center">'
                    + '<md-button class="md-icon-button" id="lines_btn"><md-icon md-font-icon="icon-file-document"></md-icon></md-button>'
                    + '<md-button id="edit_btn" class="md-icon-button"><md-icon md-font-icon="icon-pencil-box-outline" ng-click="$mdOpenMenu($event)"></md-icon></md-button>'
                    + '<md-button class="md-icon-button" id="del_btn"><md-icon md-font-icon="icon-close-circle-outline"></md-icon></md-button></div>';
        }

        function updateSearch(e){
            e.stopPropagation();
        }

        function showToast(msg) {
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');

            $mdToast.show(toast);
        }

        vm.entrega_data=null;
        vm.articles = Order.articles;
        vm.familys = Order.familys;
        vm.brands = Order.brands;
        vm.subfamilies = Order.subfamilys;

        vm.record = Order.record ? Order.record : {localentrega: '', locallevantamento: '', tipopedido: 'Implementação'};

        vm.recordLabel = Order.record ? $translate.instant('ORDER.EDIT_RECORD')+' '+Order.record.DocumentID : $translate.instant('ORDER.NEW_RECORD');
        
        if(Order.lines) {
            vm.lockswitch = true;

            vm.record.localentrega = Order.record.UnloadAddress;
            vm.record.locallevantamento = Order.record.LoadAddress;
            vm.record.dataentrega = new Date(Order.record.PlanedShipmentDate.substring(0,10));
            vm.record.horaentrega = (Order.record.PlanedShipmentDate.split(" ")[1]).substring(0,5);

            vm.record.datalevantamento = new Date(Order.record.RealShipmentDate.substring(0,10));
            vm.record.horalevantamento = (Order.record.RealShipmentDate.split(" ")[1]).substring(0,5);

            vm.products = Order.lines;
            vm.lines = Order.lines;
            vm.record.contacto = Order.record.FreeField01;
            vm.record.notes = Order.record.Observation;

            if(vm.record.DocSerie == "PI") {
                vm.s_implementacao = true;
                vm.lockinsertlocal = true;
            }
            if(vm.record.DocSerie == "PE") {
                vm.s_entrega = true;
            }
            if(vm.record.DocSerie == "PR") {
                vm.s_levantamento = true;
            }
        }
        /*vm.clients = Local.clients;
        vm.assistences = Local.assistences;

        if(vm.record)
            Local.record.code = Local.record.code.trim();*/

        vm.gotoList = gotoList;
        vm.save = save;
        vm.save_aprovar = save_aprovar;
        vm.showCatalogo = showCatalogo;
        vm.showLocal = showLocal;
        vm.deleteConfirm = deleteConfirm;
        vm.changeImplementation = changeImplementation;
        vm.changeEntrega = changeEntrega;
        vm.changeLevantamento = changeLevantamento;

        vm.submitted = false;

        function changeImplementation() {
            if(!vm.s_implementacao) {
                //vm.record.contacto = '';
            }
        }

        function changeEntrega() {
            if(!vm.s_entrega) {
                vm.record.localentrega = '';
                vm.record.dataentrega = null;
                vm.record.horaentrega = '';
            }
        }

        function changeLevantamento() {
            if(!vm.s_levantamento) {
                vm.record.locallevantamento = '';
                vm.record.datalevantamento = null;
                vm.record.horalevantamento = '';
            }
        }

        function gotoList()
        {
            $state.go('app.orders', {event: vm.sel_event});
        }

        function save(record)
        {
            var msg = '';
            vm.loading = true;

            console.log('presave',record);

            if(Order.lines) {
                record.DocumentID = Order.record.DocumentID;
                if(vm.sel_event) {
                    if(vm.sel_event.id)
                        record.event_id = vm.sel_event.eventId;
                    else
                        record.event_id = vm.sel_event.eventId;
                } else {
                    record.event_id = vm.record.EventID;
                }
            } else {
                /*record.event_id = (typeof vm.sel_event.id != 'undefined') ? vm.sel_event.eventId : vm.sel_event.eventId;*/
                record.event_id = (typeof vm.sel_event != 'undefined' && vm.sel_event !== null && typeof vm.sel_event.id != 'undefined') ? vm.sel_event.eventId : 0;
                record.CompanyID = localStorageService.get('sel_company');
            }

            record.s_implementacao = vm.s_implementacao;
            record.s_entrega = vm.s_entrega;
            record.s_levantamento = vm.s_levantamento;

            record.products = vm.products;
            record.UserID = localStorageService.get('user_id');
            record.DocumentStatus = 'Registado';
            record.Tipo = record.DocumentStatus == "Execução" ? "A" : "E";

            if(record.dataentrega != '' && typeof record.dataentrega != 'undefined') {
                record.dataentrega_f = record.dataentrega.getFullYear() + 
                    '-' + ('0' + (record.dataentrega.getMonth()+1)).slice(-2) + '-' + ('0' + record.dataentrega.getDate()).slice(-2) + ' ' + record.horaentrega;
            }

            if(record.datalevantamento != '' && typeof record.datalevantamento != 'undefined') {
                record.datalevantamento_f = record.datalevantamento.getFullYear() + 
                    '-' + ('0' + (record.datalevantamento.getMonth()+1)).slice(-2) + '-' + ('0' + record.datalevantamento.getDate()).slice(-2) + ' ' + record.horalevantamento;
            }

            api.orders.save({ record: record }).$promise.then(function (result) {
                if(record.id > 0)
                    msg = $translate.instant('ORDER.UPDATE_MSG');
                else
                    msg = $translate.instant('ORDER.INSERT_MSG');

                $state.go('app.orders', { showToastMessage: msg, event: vm.sel_event });

                vm.loading = false;
          });
        }

        function save_aprovar(record)
        {
            var msg = '';

            if(Order.lines) {
                record.DocumentID = Order.record.DocumentID;
                if(vm.sel_event) {
                    if(vm.sel_event.id)
                        record.event_id = vm.sel_event.id;
                    else
                        record.event_id = vm.sel_event.eventId;
                } else {
                    record.event_id = vm.record.EventID;
                }

            } else {
                record.event_id = (typeof vm.sel_event.id != 'undefined') ? vm.sel_event.id : vm.sel_event.eventId;
                record.CompanyID = localStorageService.get('sel_company');
            }

            record.products = vm.products;
            record.UserID = localStorageService.get('user_id');
            record.DocumentStatus = 'Execução';
            record.Tipo = "A";

            if(record.dataentrega != '' && typeof record.dataentrega != 'undefined') {
                record.dataentrega_f = record.dataentrega.getFullYear() + 
                    '-' + ('0' + (record.dataentrega.getMonth()+1)).slice(-2) + '-' + ('0' + record.dataentrega.getDate()).slice(-2) + ' ' + record.horaentrega;
            }

            if(record.datalevantamento != '' && typeof record.datalevantamento != 'undefined') {
                record.datalevantamento_f = record.datalevantamento.getFullYear() + 
                    '-' + ('0' + (record.datalevantamento.getMonth()+1)).slice(-2) + '-' + ('0' + record.datalevantamento.getDate()).slice(-2) + ' ' + record.horalevantamento;
            }

            api.orders.save({ record: record }).$promise.then(function (result) {
                if(record.id > 0)
                    msg = $translate.instant('ORDER.UPDATE_MSG');
                else
                    msg = $translate.instant('ORDER.INSERT_MSG');

                $state.go('app.orders', { showToastMessage: msg, event: vm.sel_event });
          });
        }

        function deleteConfirm(record, ev)
        {
            var confirm = $mdDialog.confirm()
                .title( $translate.instant('ORDER.DELETE_QUESTION') )
                .htmlContent('<b>' + record.Description + '</b>' + $translate.instant('ORDER.DELETE_SENTENCE'))
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok($translate.instant('ORDER.DELETE_YES'))
                .cancel($translate.instant('ORDER.DELETE_NO'));

            $mdDialog.show(confirm).then(function ()
            {
                var index = vm.products.indexOf(record);
                if (index > -1) {
                    vm.products.splice(index, 1);
                    showToast($translate.instant('ORDER.DELETE_MSG'));
                }

                /*api.locals.delete({ id: record.id }).$promise.then(function (record) {
                    vm.totalRecords = vm.totalRecords - 1;
                    vm.dtInstance.reloadData();
                    showToast($translate.instant('ORDERS.DELETE_MSG'));
                });*/
            }, function ()
            {

            });
        }

        function showCatalogo(ev) {
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/pages/order/dialog/catalogo.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                hasBackdrop: true,
                selectedOption: 'test here',
                fullscreen: false // Only for -xs, -sm breakpoints.
            })
            .then(function(answer) {
                $scope.status = 'You said the information was "' + answer + '".';
            }, function() {
                $scope.status = 'You cancelled the dialog.';
            });

        }

        function showLocal(ev) {
            $mdDialog.show({
                controller: DialogLocalController,
                templateUrl: 'app/main/pages/order/dialog/local.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                hasBackdrop: true,
                selectedOption: 'test here',
                fullscreen: false // Only for -xs, -sm breakpoints.
            })
            .then(function(answer) {
                $scope.status = 'You said the information was "' + answer + '".';
            }, function() {
                $scope.status = 'You cancelled the dialog.';
            });

        }


        function DialogLocalController($scope, $mdDialog, $filter, api) {
            $scope.abc = vm.record;
            $scope.countrys = vm.countrys;
            $scope.record = null;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.save = function(src) {
                src.CompanyID = localStorageService.get('sel_company');
                api.locations.save({ record: src }).$promise.then(function (record) {
                    vm.locations.push(record.location);
                    vm.record.localentrega = record.location.id;
                    vm.record.locallevantamento = record.location.id;
                    $mdDialog.cancel();
                });
            }
        }

        function DialogController($scope, $mdDialog, $filter) {
            $scope.i = 0;
            $scope.articles = vm.articles;
            $scope.familys = vm.familys;
            $scope.subfamilies = vm.subfamilies;
            $scope.brands = vm.brands;
            $scope.familyId=null;
            $scope.subFamily=null;
            $scope.brandId=null;

            $scope.filterProducts = function() {
                if($scope.familyId) {
                    $scope.aux = $filter('filter')(vm.articles, $scope.familyId);
                    if($scope.brandId) {
                        $scope.aux = $filter('filter')($scope.aux, $scope.brandId);
                    }
                    if($scope.subFamily) {                    
                        $scope.aux = $filter('filter')($scope.aux, $scope.subFamily);
                    }
                    $scope.articles = $scope.aux;
                } else if($scope.brandId) {                    
                    $scope.aux = $filter('filter')(vm.articles, $scope.brandId);
                    if($scope.subFamily) {                    
                        $scope.articles = $filter('filter')($scope.aux, $scope.subFamily);                    
                    }
                    $scope.articles = $scope.aux;                  
                } else if($scope.subFamily) {
                    $scope.articles = $filter('filter')(vm.articles, $scope.subFamily);                
                } else {
                    $scope.articles = vm.articles;
                }
            }

            function clone(obj) {
                if (null == obj || "object" != typeof obj) return obj;
                var copy = obj.constructor();
                for (var attr in obj) {
                    if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
                }
                return copy;
            }
    
            $scope.copyModel = function() {
                console.log("copyModel");
                $scope.filterProducts(); /* Reset vm.articles list in case of delete */
                $scope.aux1 = $scope.articles;
                $scope.aux2 = [];
                $scope.obj = {};
                angular.forEach($scope.aux1, function(value, key) {                
                    if(value.Codigo.toString().toLowerCase().indexOf($scope.search.toLowerCase()) > -1 || value.Description.toString().toLowerCase().indexOf($scope.search.toLowerCase()) > -1){
                        $scope.obj = clone(value);
                        $scope.aux2.push($scope.obj); 
                    }
                });
    
                $scope.articles = $scope.aux2;
            }

            $scope.clearFilters = function() {
                /* $scope.familyId = null;
                // $scope.subFamily = null;
                // $scope.brandId = null;
                // $scope.pesquisa = ''; */
                $scope.pesquisa.Family = undefined;
                $scope.pesquisa.SubFamily = undefined;
                $scope.pesquisa.BrandID = undefined;
                $scope.search=undefined;
                $scope.articles = vm.articles;
            }


            $scope.add = function(cod) {
                var result = vm.articles.filter(function( obj ) {
                    return obj.Codigo == cod;
                });
                var status = true;
                var aux = vm.products;
                angular.forEach(aux, function(value, key){
                    if(value.Codigo == cod) {
                        var index = vm.products.indexOf(value);

                        if (index > -1) {
                            vm.products.splice(index, 1);
                        }

                        var obj = result[0];
                        if(obj.hasOwnProperty('qtd')) {
                            obj.qtd = value.qtd +1;
                        } else {
                            obj.qtd = 1;
                        } 
                        vm.products.push(obj);
                        status = false;
                    }
                });
                if(status) {
                    var obj = result[0];
                    if(obj.hasOwnProperty('qtd')) {
                    } else {
                        obj.qtd = 1;
                    }
                    vm.products.push(obj);
                }
                $mdDialog.hide();
            }
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.filterFamily = function() {
                $scope.i = 0;
                $scope.articles = $filter('filter')(vm.articles, $scope.familyId);
            }
            /*$scope.filterProducts = function() {
                $scope.i = 0;
                $scope.aux = vm.articles;
                if($scope.familyId) {
                    console.log('f');
                    $scope.articles = $filter('filter')($scope.aux , $scope.familyId);                    
                }
                if($scope.brandId) {
                    console.log('b');
                    $scope.articles = $filter('filter')($scope.aux , $scope.brandId);

                }
            }*/
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.prev = function() {
                $scope.i = $scope.i -1;
                if($scope.i<0) {
                    $scope.i = $scope.articles.length-1;
                }
            }
            $scope.next = function() {
                $scope.i = $scope.i +1;
                if($scope.i == $scope.articles.length) {
                    $scope.i = 0;
                }
            }
            $scope.answer = function(answer) {
                $mdDialog.hide(answer);
            };
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.events', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.events', {
                url    : '/events',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pages/events/events.html',
                        controller : 'EventsController as vm'
                    }
                },
                params: {
                    showToastMessage : null,
                    client : null
                }
            });

        $translatePartialLoaderProvider.addPart('app/main/pages/events');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.events')
        .controller('EventsController', EventsController);

    /** @ngInject */
    function EventsController($compile, api, $scope, $mdToast, $state, $translate, $cookies, localStorageService, $mdDialog, $window, DTOptionsBuilder, DTColumnBuilder, CONFIG, $mdSidenav)
    {
        console.log("EventsController");

        var vm = this;
        vm.dtInstance = {};
        vm.topfilter = '';
        vm.permPrefix = "Eventos_";
        vm.perms = '';
        vm.sel_company = localStorageService.get('sel_company');

        vm.routes = null;

        vm.clients = null;
        vm.sel_client = null;
        vm.sel_client_id = null;
        
        if($state.params.client) {
            vm.sel_client = $state.params.client;
            vm.sel_client_id = $state.params.client.id;
            vm.topfilter = $state.params.client.client;
        }

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg) {
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');

            $mdToast.show(toast);
        }

        function updateSearch(e){
            e.stopPropagation();
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function actionsHtml(data, type, full, meta) {
            if(data.nrPedidos) {
                return '<div class="buttons" layout="row" layout-align="center center">'
                        + '<md-button class="md-icon-button" id="lines_btn"><md-icon md-font-icon="icon-file-document"></md-icon></md-button>'
                        + '<md-button ng-show="vm.checkPerm(\'consultar\');" id="edit_btn" class="md-icon-button"><md-icon md-font-icon="icon-pencil-box-outline" ng-click="$mdOpenMenu($event)"></md-icon></md-button>'
                        + '<md-icon md-font-icon="icon-close-circle-outline" ng-show="vm.checkPerm(\'eliminar\');"></md-icon></div>';
            } else {
                return '<div class="buttons" layout="row" layout-align="center center">'
                        + '<md-button class="md-icon-button" id="lines_btn"><md-icon md-font-icon="icon-file-document"></md-icon></md-button>'
                        + '<md-button ng-show="vm.checkPerm(\'consultar\');" id="edit_btn" class="md-icon-button"><md-icon md-font-icon="icon-pencil-box-outline" ng-click="$mdOpenMenu($event)"></md-icon></md-button>'
                        + '<md-button ng-show="vm.checkPerm(\'eliminar\');" class="md-icon-button" id="del_btn"><md-icon md-font-icon="icon-close-circle-outline"></md-icon></md-button></div>';
            }
        }

        function documentsHtml(data, type, full, meta) {
            var r = '';
            if(data.sel_docs.length > 0) {
                for(var i=0 ; i<data.sel_docs.length ; i++) {
                    r += '<md-button ng-href="http://limpalisboa.pt/api_sgeq/pdfs/'+data.sel_docs[i].talao_pdf+'" target="_blank" class="md-fab md-mini md-primary bg_red" >'
                        + '<md-tooltip md-direction="bottom">' + data.sel_docs[i].data_fim
                        + '</md-tooltip>'
                        + 'T' + data.sel_docs[i].id
                        + '</md-button>';
                }

                return r;
            } else {
                return '';
            }
        }

        function routesHtml(data, type, full, meta) {
            return '<md-select id="select_'+data.id+'" multiple placeholder="Escolha a rota" ng-change="vm.selectRoute('+data.id+')" ng-model="route_'+data.id+'" md-on-open="vm.loadRoutes('+data.id+')" style="min-width: 200px;"><md-option ng-value="route" ng-repeat="route in vm.routes">{{route.route}}</md-option></md-select>';
        }

        function createdRow(row, data, dataIndex) {
            $compile(angular.element(row).contents())($scope);
        }

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrlJson + '/json/events.php',
                type: 'POST',
                "dataSrc": function(json) {
                    console.log(json);
                    vm.perms = json.perms;
                    return json.data;
                },
                "data": function(d){
                    d.search['value'] = vm.seach_keyword;
                    d.sel_company = localStorageService.get('sel_company');
                    d.profile = localStorageService.get('profile');
                }
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('scrollY', 'auto')
            .withOption('bLengthChange', true)
            .withOption('responsive',true)
            .withPaginationType('full_numbers')
            .withOption('createdRow', createdRow)
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {

                $('td:eq(0), td:eq(1), td:eq(2), #edit_btn', nRow).css('cursor', 'pointer');
                $('td:eq(0), td:eq(1), td:eq(2), #edit_btn', nRow).unbind('click');
                $('td:eq(0), td:eq(1), td:eq(2), #edit_btn', nRow).bind('click', function() {
                    $scope.$apply(function() {
                        vm.gotoDetail(aData.eventId);
                        return nRow;
                    });
                });
                $('#del_btn', nRow).unbind('click');
                $('#del_btn', nRow).bind('click', function() {
                    $scope.$apply(function() {
                        vm.deleteConfirm(aData);
                        return nRow;
                    });
                });
                $('#lines_btn', nRow).unbind('click');
                $('#lines_btn', nRow).bind('click', function() {
                    $scope.$apply(function() {
                        vm.gotoOrders(aData);
                        return nRow;
                    });
                });
            })
            //.withOption('order', [7, 'desc'])
            .withOption('initComplete', function(){
                var api = this.api(),
                    searchBox = angular.element('body').find('#e-commerce-products-search');

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;

                if ( searchBox.length > 0 ) {
                    searchBox.on('keyup', function (event) {
                        vm.seach_keyword = event.target.value;
                        vm.dtInstance.reloadData();
                    });
                }
                $('th').css('background-color', '#2d323e');
                $('th').css('color', '#fff');
                $('th:eq(3)').css('text-align', 'center');
                $('th:last-child').css('text-align', 'center');
            })
            .withLanguage({
                "sInfo": $translate.instant('EVENTS.TABLE_INFO'),
                "paginate": {
                    "first": $translate.instant('EVENTS.TABLE_BUT_FIRST'),
                    "last": $translate.instant('EVENTS.TABLE_BUT_LAST'),
                    "next": $translate.instant('EVENTS.TABLE_BUT_NEXT'),
                    "previous": $translate.instant('EVENTS.TABLE_BUT_PREVIOUS')
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('title').withTitle($translate.instant('EVENTS.TABLE_EVENT')),
            DTColumnBuilder.newColumn('StartDate').withTitle($translate.instant('EVENTS.TABLE_STARTDATE')),
            DTColumnBuilder.newColumn('EndDate').withTitle($translate.instant('EVENTS.TABLE_ENDDATE')),
            DTColumnBuilder.newColumn(null).withTitle($translate.instant('EVENTS.TABLE_ACTIONS')).notSortable()
                .renderWith(actionsHtml).withOption('width', '100px'),
            DTColumnBuilder.newColumn('eventId').notVisible()
        ];

        vm.filterClients = filterClients;
        vm.loadClients = loadClients;
        vm.selectRoute = selectRoute;
        vm.loadRoutes = loadRoutes;
        vm.checkPerm = checkPerm;

        function checkPerm(perm) {
            if(vm.perms.indexOf(vm.permPrefix+perm)>-1) {
                return true;
            } else {
                return false;
            }
        }

        /* FILTERS */
        function filterClients() {
            if(vm.sel_client) {
                vm.sel_client_id = vm.sel_client.id;
                vm.dtInstance.reloadData();
            }
        }

        /* LOADS */
        function loadClients() {
            var promisse = api.clients.get().$promise;
            promisse.then(function (collection) {
                vm.clients = collection.records;
            });
        }

        function loadRoutes(routeId) {
            /*console.log("OK");
            var a = $('#select_'+routeId);
            console.log(a);*/
        }

        function selectRoute(localId) {
            var aux = "route_" + localId;
            $scope.routes = [];
            angular.forEach($scope[aux], function(value, key) {
                $scope.record = {
                    routeId : value.id,
                    localId : localId
                };
                $scope.routes.push($scope.record);
            });
            api.routelocals.save({ record: $scope.routes }).$promise.then(function (result) {
            });
        }


        // Methods
        vm.gotoDetail       = gotoDetail;
        vm.deleteConfirm    = deleteConfirm;
        vm.toggleSidenav    = toggleSidenav;
        vm.updateSearch     = updateSearch;
        vm.haveFilters      = haveFilters;
        vm.clearFilters     = clearFilters;
        vm.gotoOrders       = gotoOrders;

        function gotoOrders(src)
        {
            $state.go('app.orders', {event: src});
        }

        function haveFilters()
        {
            if(vm.sel_client_id > 0)
                return true;
            else
                return false;
        }

        function clearFilters()
        {
            vm.sel_client_id = null;
            vm.sel_client = null;
            vm.dtInstance.reloadData();
        }

        function gotoDetail(id)
        {
            $state.go('app.event', {id: id});
        }

        function deleteConfirm(record, ev)
        {
            var confirm = $mdDialog.confirm()
                .title( $translate.instant('EVENTS.DELETE_QUESTION') )
                .htmlContent('<b>' + record.title + '</b>' + $translate.instant('EVENTS.DELETE_SENTENCE'))
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok($translate.instant('EVENTS.DELETE_YES'))
                .cancel($translate.instant('EVENTS.DELETE_NO'));

            $mdDialog.show(confirm).then(function ()
            {
                api.events.delete({ id: record.eventId }).$promise.then(function (record) {
                    vm.totalRecords = vm.totalRecords - 1;
                    vm.dtInstance.reloadData();
                    showToast($translate.instant('EVENTS.DELETE_MSG'));
                });
            }, function ()
            {

            });
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.event', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, $mdDateLocaleProvider)
    {
    $mdDateLocaleProvider.formatDate = function(date) {
       return moment(date).format('YYYY-MM-DD');
    };

        $stateProvider
          .state('app.event', {
              url      : '/event/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/event/event.html',
                      controller : 'EventController as vm'
                  }
              },
              resolve  : {
                  Event: function (api, $stateParams, localStorageService)
                  {
                      return api.events.get({ id: $stateParams.id, profile: localStorageService.get('profile') }).$promise;
                  }
              },
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/event');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.event')
        .controller('EventController', EventController);

    function EventController($scope, $document, $state, Event, api, $window, $translate, localStorageService)
    {
        console.log("EventController", Event);

        var vm = this;

        if(Event.record) {
            vm.create_user = 'Criado por: ' + Event.user;
            vm.nrPedidos = Event.pedidos;
            vm.record = Event.record;
            vm.record.StartDate = new Date(vm.record.StartDate);
            vm.record.EndDate = new Date(vm.record.EndDate);
            vm.recordLabel = Event.record.EventDescription;
            vm.IsActive = Event.record.IsActive ==1 ? true : false;
        } else {
            vm.create_user = "";
            vm.nrPedidos = 0;
            vm.IsActive = true;
            vm.record = null;
            vm.recordLabel = $translate.instant('EVENT.NEW_RECORD');
        }

        vm.perms = Event.perms;
        vm.permPrefix = "Eventos_";
        //vm.clients = Local.clients;
        //vm.assistences = Local.assistences;

        //if(vm.record)
        //    Local.record.code = Local.record.code.trim();

        vm.gotoList = gotoList;
        vm.save = save;
        vm.checkPerm = checkPerm;

        function checkPerm(perm) {
            if(vm.perms.indexOf(vm.permPrefix+perm)>-1) {
                return true;
            } else {
                return false;
            }
        }

        vm.submitted = false;

        function gotoList()
        {
            $state.go('app.events');
        }

        function save(record)
        {
            var msg = '';

            var datai = record.StartDate.getFullYear() + '-' + ('0' + (record.StartDate.getMonth()+1)).slice(-2) + '-'+ ('0' + record.StartDate.getDate()).slice(-2);
            var dataf = record.EndDate.getFullYear() + '-' + ('0' + (record.EndDate.getMonth()+1)).slice(-2) + '-'+ ('0' + record.EndDate.getDate()).slice(-2);

            record.CompanyID = localStorageService.get('sel_company');
            record.user_id = localStorageService.get('user_id');
            record.datai = datai;
            record.dataf = dataf;
            record.IsActive = vm.IsActive ? 1 : 0;

            api.events.save({ record: record }).$promise.then(function (result) {
                if(record.id != '')
                    msg = $translate.instant('EVENT.UPDATE_MSG');
                else
                    msg = $translate.instant('EVENT.INSERT_MSG');

                $state.go('app.events', { showToastMessage: msg });
          });
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.catalog', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.catalog', {
              url      : '/catalog/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/catalog/catalog.html',
                      controller : 'CatalogController as vm'
                  }
              },
              resolve  : {
                  Catalog: function (api, $stateParams, localStorageService)
                  {
                    return api.articles.get({ id: 0, company: localStorageService.get('sel_company')}).$promise;
                  }
              },
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/catalog');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.catalog')
        .controller('CatalogController', CatalogController);

    function CatalogController($scope, $document, $state, Catalog, api, $window, $translate, $filter)
    {
        var vm = this;

        vm.articles = Catalog.records;
        vm.familys = Catalog.familys;
        vm.subfamilies = Catalog.subfamilys;
        vm.brands = Catalog.brands;
        vm.familyId=null;        
        vm.pesquisa={};
        vm.brandId=null;
        vm.subFamily=null;
        vm.search=null;

        vm.gotoDetail = gotoDetail;
        vm.filterProducts = filterProducts;
        vm.clearFilters = clearFilters;
        vm.copyModel = copyModel;

        function clearFilters() {
            vm.pesquisa.Family = undefined;
            vm.pesquisa.SubFamily = undefined;
            vm.pesquisa.BrandID = undefined;
            vm.search=undefined;
            vm.articles = Catalog.records;
        }

        function clone(obj) {
            if (null == obj || "object" != typeof obj) return obj;
            var copy = obj.constructor();
            for (var attr in obj) {
                if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
            }
            return copy;
        }

        function copyModel() {
            console.log("copyModel");
            filterProducts(); /* Reset vm.articles list in case of delete */
            vm.aux1 = vm.articles;
            vm.aux2 = [];
            vm.obj = {};
            angular.forEach(vm.aux1, function(value, key) {                
                if(value.Codigo.toString().toLowerCase().indexOf(vm.search.toLowerCase()) > -1 || value.Description.toString().toLowerCase().indexOf(vm.search.toLowerCase()) > -1){
                    vm.obj = clone(value);
                    vm.aux2.push(vm.obj); 
                }
            });

            vm.articles = vm.aux2;
        }

        function filterProducts() {
            if(vm.familyId) {
                vm.aux = $filter('filter')(Catalog.records, vm.familyId);
                if(vm.brandId) {
                    vm.aux = $filter('filter')(vm.aux, vm.brandId);
                }
                if(vm.subFamily) {
                    vm.aux = $filter('filter')(vm.aux, vm.subFamily);
                }
                vm.articles = vm.aux;
            } else if(vm.brandId) {
                vm.aux = $filter('filter')(Catalog.records, vm.brandId);
                if(vm.subFamily) {
                    vm.aux = $filter('filter')(vm.aux, vm.subFamily);
                }
                vm.articles = vm.aux;
            } else if(vm.subFamily) {
                vm.articles = $filter('filter')(vm.articles, vm.subFamily);
            } else {
                vm.articles = Catalog.records;
            }
        }

        function gotoDetail(src)
        {
            $state.go('app.article', {id: src, catalog: true});
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.calendar')
        .controller('CalendarController', CalendarController);

    /** @ngInject */
    function CalendarController($mdDialog, $document, $state, Events, localStorageService,$translate)
    {
        var vm = this;
        vm.profile = localStorageService.get('profile');

        console.log("TESTE:",Events);

        // Data
        var date = new Date();
        var d = date.getDate();
        var m = date.getMonth();
        var y = date.getFullYear();
        var events = [];
        var i=1;

        Events.records.forEach(function(entry) {
            entry.eventId = entry.id;
            entry.EventCompany = entry.CompanyID;
            entry.id = i;

            if(entry.IsActive == 0) {
                entry.color = 'grey';
            } else {
                if(entry.activos > 0) {
                    entry.color = 'green';
                } else {
                    if(entry.inactivos > 0) {
                        entry.color = 'red';
                    } else {
                        entry.color = 'blue';
                    }
                }
            }
            events.push(entry);
            i++;
        });

        vm.events = [events];
        vm.nrEvents = i-1;
        vm.nrRegistados = Events.registados;
        vm.nrAprovados = Events.aprovados;
        vm.eventossempedidos = Events.eventossempedidos;
        vm.pedidosporresponder = Events.pedidosporresponder;
        
        vm.march=$translate.instant('CALENDAR.MARCH');
        vm.march=vm.march.replace("Mar&#231;o", "Março");

        vm.calendarUiConfig = {
            calendar: {
                //editable          : true,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                dayNames          : ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
                dayNamesShort     : [$translate.instant('CALENDAR.SUN'), $translate.instant('CALENDAR.MON'), $translate.instant('CALENDAR.TUE'), $translate.instant('CALENDAR.WED'), $translate.instant('CALENDAR.THU'), $translate.instant('CALENDAR.FRI'), $translate.instant('CALENDAR.SAT')],
                monthNames        : [$translate.instant('CALENDAR.JANUARY'),$translate.instant('CALENDAR.FEBRUARY'),vm.march,$translate.instant('CALENDAR.APRIL'),$translate.instant('CALENDAR.MAY'),$translate.instant('CALENDAR.JUNE'),$translate.instant('CALENDAR.JULY'),$translate.instant('CALENDAR.AUGUST'),$translate.instant('CALENDAR.SEPTEMBER'),$translate.instant('CALENDAR.OCTOBER'),$translate.instant('CALENDAR.NOVEMBER'),$translate.instant('CALENDAR.DECEMBER')],
                viewRender        : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M'
                },
                eventClick        : eventDetail,
                selectable        : true,
                selectHelper      : true,
                select            : select,
                displayEventTime: false
            }
        };

        // Methods
        vm.addEvent = addEvent;
        vm.next = next;
        vm.prev = prev;

        //////////

        /**
         * Go to next on current view (week, month etc.)
         */
        function next()
        {
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev()
        {
            vm.calendarView.calendar.prev();
        }

        /**
         * Show event detail
         *
         * @param calendarEvent
         * @param e
         */
        function eventDetail(calendarEvent, e)
        {
            $state.go('app.orders', {event: calendarEvent});
        }

        /**
         * Add new event in between selected dates
         *
         * @param start
         * @param end
         * @param e
         */
        function select(start, end, event)
        {
            showEventFormDialog('add', false, start, end, event);
        }

        /**
         * Add event
         *
         * @param e
         */
        function addEvent(event)
        {
            var start = new Date(),
                end = new Date();

            showEventFormDialog('add', false, start, end, event);
        }

        /**
         * Show event detail dialog
         * @param calendarEvent
         * @param e
         */
        function showEventDetailDialog(calendarEvent, event)
        {
            $mdDialog.show({
                controller         : 'EventDetailDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/calendar/dialogs/event-detail/event-detail-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : event,
                clickOutsideToClose: true,
                locals             : {
                    calendarEvent      : calendarEvent,
                    showEventFormDialog: showEventFormDialog,
                    event              : event
                }
            });
        }

        /**
         * Show event add/edit form dialog
         *
         * @param type
         * @param calendarEvent
         * @param start
         * @param end
         * @param e
         */
        function showEventFormDialog(type, calendarEvent, start, end, event)
        {
            var dialogData = {
                type         : type,
                calendarEvent: calendarEvent,
                start        : start,
                end          : end
            };

            $mdDialog.show({
                controller         : 'EventFormDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/calendar/dialogs/event-form/event-form-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : event,
                clickOutsideToClose: true,
                locals             : {
                    dialogData: dialogData
                }
            }).then(function (response)
            {
                switch ( response.type )
                {
                    case 'add':
                        // Add new
                        vm.events[0].push({
                            id   : vm.events[0].length + 20,
                            title: response.calendarEvent.title,
                            start: response.calendarEvent.start,
                            end  : response.calendarEvent.end
                        });
                        break;

                    case 'edit':
                        // Edit
                        for ( var i = 0; i < vm.events[0].length; i++ )
                        {
                            // Update
                            if ( vm.events[0][i].id === response.calendarEvent.id )
                            {
                                vm.events[0][i] = {
                                    title: response.calendarEvent.title,
                                    start: response.calendarEvent.start,
                                    end  : response.calendarEvent.end
                                };

                                break;
                            }
                        }
                        break;

                    case 'remove':
                        // Remove
                        for ( var j = 0; j < vm.events[0].length; j++ )
                        {
                            // Update
                            if ( vm.events[0][j].id === response.calendarEvent.id )
                            {
                                vm.events[0].splice(j, 1);

                                break;
                            }
                        }
                        break;
                }
            });
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.articles', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.articles', {
                url    : '/articles',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pages/articles/articles.html',
                        controller : 'ArticlesController as vm'
                    }
                },
                params: {
                    showToastMessage : null,
                    client : null
                }
            });

        $translatePartialLoaderProvider.addPart('app/main/pages/articles');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.articles')
        .controller('ArticlesController', ArticlesController);

    /** @ngInject */
    function ArticlesController($compile, api, $scope, $mdToast, $state, $translate, $cookies, localStorageService, $mdDialog, $window, DTOptionsBuilder, DTColumnBuilder, CONFIG, $mdSidenav)
    {
        console.log("ArticlesController");

        var vm = this;
        vm.dtInstance = {};
        vm.topfilter = '';

        vm.changestatus = changestatus;

        vm.permPrefix = "Produtos_"
        vm.perms = '';

        vm.routes = null;

        vm.clients = null;
        vm.sel_client = null;
        vm.sel_client_id = null;
        
        if($state.params.client) {
            vm.sel_client = $state.params.client;
            vm.sel_client_id = $state.params.client.id;
            vm.topfilter = $state.params.client.client;
        }

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function changestatus(articleId, status, elem) {

            api.articles.save({ id: articleId, status: status }).$promise.then(function (response) {
                var rows = vm.dtInstance.DataTable.rows().data();
                for(var i=0; i<rows.length; i++) {
                    if(rows[i].id == articleId) {
                        rows[i].Status = "0";
                        vm.dtInstance.reloadData();
                        break;
                    }
                }
            });

        }

        function showToast(msg) {
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');

            $mdToast.show(toast);
        }

        function updateSearch(e){
            e.stopPropagation();
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function actionsHtml(data, type, full, meta) {
            return '<div class="buttons" layout="row" layout-align="center center">'
                    /*+ '<md-button ng-if="'+data.Status+'==1" id="edit_btn" class="md-icon-button" ng-click="vm.changestatus(\''+data.id+'\', 0, this)">'
                    +   '<md-icon md-font-icon="icon-checkbox-marked-circle-outline" style="color:green;font:bold;"></md-icon>'
                    + '</md-button>'
                    + '<md-button ng-if="'+data.Status+'==0" id="edit_btn" class="md-icon-button" ng-click="vm.changestatus(\''+data.id+'\', 1, this)">'
                    +   '<md-icon md-font-icon="icon-close-circle-outline" style="color:red;font:bold;"></md-icon>'
                    + '</md-button>'*/
                    + '<md-button ng-show="vm.checkPerm(\'consultar\');" id="edit_btn" class="md-icon-button">'
                    +   '<md-icon md-font-icon="icon-pencil-box-outline" ng-click="$mdOpenMenu($event)"></md-icon>'
                    + '</md-button>'
                    + '</div>';
        }

        function documentsHtml(data, type, full, meta) {
            var r = '';
            if(data.sel_docs.length > 0) {
                for(var i=0 ; i<data.sel_docs.length ; i++) {
                    r += '<md-button ng-href="http://limpalisboa.pt/api_sgeq/pdfs/'+data.sel_docs[i].talao_pdf+'" target="_blank" class="md-fab md-mini md-primary bg_red" >'
                        + '<md-tooltip md-direction="bottom">' + data.sel_docs[i].data_fim
                        + '</md-tooltip>'
                        + 'T' + data.sel_docs[i].id
                        + '</md-button>';
                }

                return r;
            } else {
                return '';
            }
        }

        function routesHtml(data, type, full, meta) {
            return '<md-select id="select_'+data.id+'" multiple placeholder="Escolha a rota" ng-change="vm.selectRoute('+data.id+')" ng-model="route_'+data.id+'" md-on-open="vm.loadRoutes('+data.id+')" style="min-width: 200px;"><md-option ng-value="route" ng-repeat="route in vm.routes">{{route.route}}</md-option></md-select>';
        }

        function createdRow(row, data, dataIndex) {
            $compile(angular.element(row).contents())($scope);
        }

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrlJson + 'json/articles.php',
                type: 'POST',
                "dataSrc": function(json) {
                    vm.perms = json.perms;
                    return json.data;
                },
                "data": function(d){
                    d.search['value'] = vm.seach_keyword;
                    d.sel_company = localStorageService.get('sel_company');
                    d.profile = localStorageService.get('profile');
                }
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('scrollY', 'auto')
            .withOption('bLengthChange', true)
            .withOption('responsive',true)
            .withPaginationType('full_numbers')
            .withOption('createdRow', createdRow)
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {

                $('td:eq(0), td:eq(1), td:eq(2), #edit_btn', nRow).css('cursor', 'pointer');
                $('td:eq(0), td:eq(1), td:eq(2), #edit_btn', nRow).unbind('click');
                $('td:eq(0), td:eq(1), td:eq(2), #edit_btn', nRow).bind('click', function() {
                    $scope.$apply(function() {
                        vm.gotoDetail(aData.id);
                        return nRow;
                    });
                });
                $('#del_btn', nRow).unbind('click');
                $('#del_btn', nRow).bind('click', function() {
                    $scope.$apply(function() {
                        vm.deleteConfirm(aData);
                        return nRow;
                    });
                });
                $('#lines_btn', nRow).unbind('click');
                $('#lines_btn', nRow).bind('click', function() {
                    $scope.$apply(function() {
                        vm.gotoEquipments(aData);
                        return nRow;
                    });
                });
            })
            //.withOption('order', [7, 'desc'])
            .withOption('initComplete', function(){
                var api = this.api(),
                    searchBox = angular.element('body').find('#e-commerce-products-search');

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;

                if ( searchBox.length > 0 ) {
                    searchBox.on('keyup', function (event) {
                        vm.seach_keyword = event.target.value;
                        vm.dtInstance.reloadData();
                    });
                }
                $('th').css('background-color', '#2d323e');
                $('th').css('color', '#fff');
                $('th:eq(3)').css('text-align', 'center');
                $('th:last-child').css('text-align', 'center');
            })
            .withLanguage({
                "sInfo": $translate.instant('ARTICLES.TABLE_INFO'),
                "paginate": {
                    "first": $translate.instant('ARTICLES.TABLE_BUT_FIRST'),
                    "last": $translate.instant('ARTICLES.TABLE_BUT_LAST'),
                    "next": $translate.instant('ARTICLES.TABLE_BUT_NEXT'),
                    "previous": $translate.instant('ARTICLES.TABLE_BUT_PREVIOUS')
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('description').withTitle($translate.instant('ARTICLES.TABLE_DESCRIPTION')),
            DTColumnBuilder.newColumn('family').withTitle($translate.instant('ARTICLES.TABLE_FAMILY')),
            DTColumnBuilder.newColumn('type').withTitle($translate.instant('ARTICLES.TABLE_TYPE')),
            DTColumnBuilder.newColumn('brandid').withTitle($translate.instant('ARTICLES.TABLE_BRAND')),
            DTColumnBuilder.newColumn('stock').withTitle($translate.instant('ARTICLES.TABLE_STOCK')),
            DTColumnBuilder.newColumn(null).withTitle($translate.instant('ARTICLES.TABLE_ACTIONS')).notSortable()
                .renderWith(actionsHtml).withOption('width', '100px'),
            DTColumnBuilder.newColumn('id').notVisible()
        ];

        vm.filterClients = filterClients;
        vm.loadClients = loadClients;
        vm.selectRoute = selectRoute;
        vm.loadRoutes = loadRoutes;
        vm.checkPerm = checkPerm;

        function checkPerm(perm) {
            if(vm.perms.indexOf(vm.permPrefix+perm)>-1) {
                return true;
            } else {
                return false;
            }
        }

        /* FILTERS */
        function filterClients() {
            if(vm.sel_client) {
                vm.sel_client_id = vm.sel_client.id;
                vm.dtInstance.reloadData();
            }
        }

        /* LOADS */
        function loadClients() {
            var promisse = api.clients.get().$promise;
            promisse.then(function (collection) {
                vm.clients = collection.records;
            });
        }

        function loadRoutes(routeId) {
            /*console.log("OK");
            var a = $('#select_'+routeId);
            console.log(a);*/
        }

        function selectRoute(localId) {
            var aux = "route_" + localId;
            $scope.routes = [];
            angular.forEach($scope[aux], function(value, key) {
                $scope.record = {
                    routeId : value.id,
                    localId : localId
                };
                $scope.routes.push($scope.record);
            });
            api.routelocals.save({ record: $scope.routes }).$promise.then(function (result) {
            });
        }


        // Methods
        vm.gotoDetail       = gotoDetail;
        vm.deleteConfirm    = deleteConfirm;
        vm.toggleSidenav    = toggleSidenav;
        vm.updateSearch     = updateSearch;
        vm.haveFilters      = haveFilters;
        vm.clearFilters     = clearFilters;
        vm.gotoEquipments   = gotoEquipments;

        function gotoEquipments(src)
        {
            $state.go('app.equipments', {local: src});
        }

        function haveFilters()
        {
            if(vm.sel_client_id > 0)
                return true;
            else
                return false;
        }

        function clearFilters()
        {
            vm.sel_client_id = null;
            vm.sel_client = null;
            vm.dtInstance.reloadData();
        }

        function gotoDetail(id)
        {
            console.log(id);
            $state.go('app.article', {id: id});
        }

        function deleteConfirm(record, ev)
        {
            var confirm = $mdDialog.confirm()
                .title( $translate.instant('ARTICLES.DELETE_QUESTION') )
                .htmlContent('<b>' + record.description + '</b>' + $translate.instant('ARTICLES.DELETE_SENTENCE'))
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok($translate.instant('ARTICLES.DELETE_YES'))
                .cancel($translate.instant('ARTICLES.DELETE_NO'));

            $mdDialog.show(confirm).then(function ()
            {
                api.locals.delete({ id: record.id }).$promise.then(function (record) {
                    vm.totalRecords = vm.totalRecords - 1;
                    vm.dtInstance.reloadData();
                    showToast($translate.instant('ARTICLES.DELETE_MSG'));
                });
            }, function ()
            {

            });
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.article', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.article', {
              url      : '/article/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/article/article.html',
                      controller : 'ArticleController as vm'
                  }
              },
              resolve  : {
                  Article: function (api, $stateParams)
                  {
                      console.log('id=' + $stateParams.id);
                      return api.articles.get({ id: encodeURIComponent($stateParams.id) }).$promise;
                  }
              },
                params: {
                    catalog : null
                },
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/article');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.article')
        .controller('ArticleController', ArticleController);

    function ArticleController($compile,$scope, $document, $state, Article, api, $window, $translate, DTOptionsBuilder, DTColumnBuilder)
    {
        console.log("ArticleController",Article);

        var vm = this;
        vm.dtInstance = {};

        vm.locals = Article.locals;
        vm.catalog = 0;

        if($state.params.catalog > 0) {
            vm.catalog = 1;
        }

        vm.record = Article.record ? Article.record : null;
        vm.recordLabel = Article.record ? (Article.record.Description ? Article.record.Description : $translate.instant('LOCAL.NEW_RECORD')) : $translate.instant('LOCAL.NEW_RECORD');

        vm.gotoList = gotoList;
        vm.verPedido = verPedido;
        vm.save = save;
        vm.isImage = isImage;

        vm.submitted = false;

        function verPedido(id)
        {
            $state.go('app.order', {id: id});
        }

        function gotoList()
        {
            if( vm.catalog == 1) {
                $state.go('app.catalog');
            } else {
                $state.go('app.articles');
            }
        }

        function isImage(src) {

            var deferred = $q.defer();

            var image = new Image();
            image.onerror = function() {
                deferred.resolve(false);
            };
            image.onload = function() {
                deferred.resolve(true);
            };
            image.src = src;

            return deferred.promise;
        }

        function save(record)
        {
            var msg = '';
            api.locals.save({ record: record }).$promise.then(function (result) {
                if(record.id > 0)
                    msg = $translate.instant('LOCAL.UPDATE_MSG');
                else
                    msg = $translate.instant('LOCAL.INSERT_MSG');

                $state.go('app.locals', { showToastMessage: msg });
          });
        }

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>');

        vm.dtColumns = [
            DTColumnBuilder.newColumn('Codigo').withTitle('Cod'),
            DTColumnBuilder.newColumn('Description').withTitle('Artigo'),
            DTColumnBuilder.newColumn('qtd').withTitle('Qtd'),
            DTColumnBuilder.newColumn('sn').withTitle('S/N'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').notSortable()
                .renderWith(actionsHtml).withOption('width', '100px'),
            DTColumnBuilder.newColumn('cod').notVisible()
        ];

        function createdRow(row, data, dataIndex) {
            $compile(angular.element(row).contents())($scope);
        }

        function actionsHtml(data, type, full, meta) {
            return '<div class="buttons" layout="row" layout-align="center center"><md-button class="md-icon-button" id="lines_btn"><md-icon md-font-icon="icon-file-document"></md-icon></md-button><md-button id="edit_btn" class="md-icon-button"><md-icon md-font-icon="icon-pencil-box-outline" ng-click="$mdOpenMenu($event)"></md-icon></md-button><md-button class="md-icon-button" id="del_btn"><md-icon md-font-icon="icon-close-circle-outline"></md-icon></md-button></div>';
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngMaterial',
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
                'datatables',
                'angular-jwt',
                'LocalStorageModule',
                'angular-md5',
                'ui.calendar',
                '720kb.datepicker',
                'ngFileUpload'
            ]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
            
            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);
                    
                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {

        $mdThemingProvider.theme("success-toast");
        $mdThemingProvider.theme("error-toast");

        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'yellow',
                hues: {
                    'default': '100',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'yellow',
            options: {
                '50': '#000', //background menu with focus
                '100': '#4ED9FF', //background top pages
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('authService', authService);

    /** @ngInject */
    function authService(localStorageService)
    {
        var profile = function profile() {
            return localStorageService.get('profile');
        }

        return {
            getProfile: function getProfile()
            {
                return profile();
            }
        }

    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'E',
            compile : function (element, attr)
            {
                var code;
                //No attribute? code is the content
                if ( !attr.code )
                {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr)
                {

                    if ( attr.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, localStorageService)
    {
        var vm = this;
        vm.username = localStorageService.get('username');

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.languages = {
            pt: {
                'title'      : 'Português',
                'translation': 'TOOLBAR.PORTUGUESE',
                'code'       : 'pt',
                'flag'       : 'pt'
            },
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'en'
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.logout = logout;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout()
        {
            localStorageService.clearAll();
            $state.go('app.auth');
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, CONFIG, $sanitize, localStorageService, $state)
    {
        var vm = this;

        vm.username = localStorageService.get('username');
        vm.companys = localStorageService.get('companys');
        vm.logo = localStorageService.get('logo');

        vm.sel_company = localStorageService.get('sel_company');
        vm.profile = localStorageService.get('profile');

        vm.update_company = update_company;

        function update_company() {
            if(vm.sel_company) {
                localStorageService.set('sel_company', vm.sel_company);
                $state.reload();
            }
        }

        vm.defaultLogo = $sanitize(CONFIG.defaultLogo);
        vm.title = $sanitize(CONFIG.title);

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.recover', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
            .state('app.recover', {
                url    : '/recovery/:token',
                views    : {
                    'main@'                       : {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller : 'MainController as vm'
                    },
                    'content@app.recover': {
                        templateUrl: 'app/recover/recover.html',
                        controller : 'RecoverController as vm'
                    }
                },
                bodyClass: 'login'
            });

        $translatePartialLoaderProvider.addPart('app/recover');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.recover')
        .controller('RecoverController', RecoverController);

    /** @ngInject */
    function RecoverController($state, $translate, $cookies, CONFIG, $sanitize, $window, $http, $mdToast, msNavigationService)
    {
      var vm = this;
      vm.loginLogo = $sanitize(CONFIG.loginLogo);

      vm.token = ($state.params.token) ? $state.params.token : "";

      vm.recover = function(email) {

        vm.loading = true;

        $http.post(CONFIG.apiBaseUrl + 'Recover',
          { email: email })
        .success(function (response) {
          if(response.status){
            vm.error = response.status;
            vm.loading = false;
            var toast = $mdToast.simple()
                .content(vm.error)
                .highlightAction(true)
                .hideDelay(10000)
                .position('top right');  
            $mdToast.show(toast);
          }
        });
      
      }

      vm.definepwd = function(token,password) {

        vm.loading = true;

        $http.post(CONFIG.apiBaseUrl + 'Recover/update',
          { token: token, password: password })
        .success(function (response) {
          if(response.status){
            vm.error = response.status;
            vm.loading = false;
            var toast = $mdToast.simple()
                .content(vm.error)
                .highlightAction(true)
                .hideDelay(15000)
                .position('top right');  
            $mdToast.show(toast);
          }
        });
      
      }


    }
})();

(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Auth
            'app.auth',

            // Recover
            'app.recover',

            // Pages
            'app.pages'

        ]);
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, authService, msNavigationService)
    {
        // Data
        //////////
        console.log("MainController");

        /*msNavigationService.saveItem('app.clients', {
            title    : 'Dashboard',
            icon     : 'icon-account-multiple',
            state    : 'app.clients',
            hidden: function ()
            {
                return authService.getProfile() != "ADMIN";
            },
            translate: 'CLIENTS.NAV',
            weight   : 5
        });*/


        msNavigationService.saveItem('app', {
            title : 'Menu',
            group : true,
            weight: 1
        });

        msNavigationService.saveItem('app.calendar', {
            title    : 'Dashboard',
            icon     : 'icon-tile-four',
            state    : 'app.calendar',

            translate: 'CALENDAR.CALENDAR',
            weight   : 1
        });

        msNavigationService.saveItem('app.events', {
            title    : 'Eventos',
            icon     : 'icon-calendar-clock',
            state    : 'app.events',

            translate: 'EVENTS.NAV',
            weight   : 2
        });

        msNavigationService.saveItem('app.orders', {
            title    : 'Orders',
            icon     : 'icon-file-document',
            state    : 'app.orders',

            translate: 'ORDERS.NAV',
            weight   : 3
        });

        msNavigationService.saveItem('app.articles', {
            title    : 'Articles',
            icon     : 'icon-cube-outline',
            state    : 'app.articles',

            translate: 'ARTICLES.NAV',
            weight   : 4
        });

        msNavigationService.saveItem('app.catalog', {
            title    : 'Catalog',
            icon     : 'icon-apps',
            state    : 'app.catalog',

            translate: 'CATALOG.NAV',
            weight   : 5
        });

        msNavigationService.saveItem('app.users', {
            title    : 'Pedidos',
            icon     : 'icon-account-key',
            state    : 'app.users',
            translate: 'USERS.NAV',
            weight   : 6,
            hidden: function ()
            {
                return authService.getProfile() != "ADMIN";
            },
        });


        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('pt');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
            .state('app.auth', {
                url    : '/login',
                views    : {
                    'main@'                       : {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller : 'MainController as vm'
                    },
                    'content@app.auth': {
                        templateUrl: 'app/auth/auth.html',
                        controller : 'AuthController as vm'
                    }
                },
                bodyClass: 'login'
            });

        $translatePartialLoaderProvider.addPart('app/auth');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth')
        .controller('AuthController', AuthController);

    /** @ngInject */
    function AuthController($state, $translate, $cookies, CONFIG, $sanitize, $window, api, $mdToast, msNavigationService)
    {
      var vm = this;
      vm.loginLogo = $sanitize(CONFIG.loginLogo);

      vm.recover = function()
        {
            $state.go('app.recover');
        }

      vm.login = function(username, password) {
      vm.loading = true;

        api.Login(username, password, function (result) {
          if (result === true) {
              $state.go('app.calendar');
          } else {
              //exibir mensagens de erro consoante o erro
              vm.error = 'Nome do utilizador ou password inválidas';
              vm.loading = false;
              var toast = $mdToast.simple()
                  .content(vm.error)
                  .highlightAction(true)
                  .hideDelay(3000)
                  .position('top right');

              $mdToast.show(toast);
          }
        });        

        /*        var expToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjEiLCJuYW1lIjoiQWRtaW5pc3RyYXRvciIsInJ1bGVzIjpbeyJtZW51IjoiQ2xpZW50cyIsInBlZGl0IjoiMSIsInBuZXciOiIxIiwicGRlbCI6IjEifV19.RKn27ls3YRZzYdwoKX0WsAbOTGytk30omSngtUeoJ4o";
                var tokenPayload = jwtHelper.decodeToken(expToken);
                console.log(tokenPayload);

                var date = jwtHelper.getTokenExpirationDate(expToken);
                console.log(date);*/

/*
        api.clients.query().$promise.then(function (result) {
            console.log(result[0]);
        });
*/
        /*
        api.get({ id: 41 }).$promise.then(function (result) {
          var user = result.client;
          user.client = ' de Belmonte';
          console.log(user);

          /*api.save({ client: user }).$promise.then(function (result) {
            console.log("user updated");
          });*/

          /*user.client.client = user.client.client + ' de Belmonte';
          user.client.$update(function(){//Then send an update HTTP PUT to server.
                console.log('Updating user with id ',user.id);
              });
        });*/
/*
        api.get({ id: 41 }).$promise.then(function (result) {
          var user = result.client;
          user.morada2 = 'Ericeira';

          api.save(user, function(response){
              console.log("fim");
            });


        });

        //DELETE
        /*
        api.delete({ id: 43 }).$promise.then(function (user) {
                console.log('delete');
        });
        */

        /*api.save({id:41,localidade:'Mafra'}, function(response){
						console.log("fim");
					});*/

        /*
        api.get({ id: 33 }.$promise, function(data) {
          console.log(data);
        });
/*
          api.user.login.login({'user': user, 'pass' : password},

              // Success
              function (response)
              {
                console.log(response);
                  if(response.status == 'OK') {
                    var user = response.user;
                      $window.localStorage.setItem('user',user.name);
                      $window.localStorage.setItem('lang',user.language_code);
                      $window.location.href = '/clients';
                  } else {

                      var toast = $mdToast.simple()
                          .content(response.status)
                          .highlightAction(true)
                          .hideDelay(3000)
                          .position('top right');

                      $mdToast.show(toast);
                  }
              },
              // Error
              function (response)
              {
                                console.log(response);
                      var toast = $mdToast.simple()
                          .content(response.status)
                          .highlightAction(true)
                          .hideDelay(0)
                          .position('top right');

                      $mdToast.show(toast);
              }
          );*/
      }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/login');

        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: 'app/core/layouts/vertical-navigation.html',
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: 'app/navigation/layouts/vertical-navigation/navigation.html',
                        controller : 'NavigationController as vm'
                    }
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming, localStorageService, $http, jwtHelper, CONFIG, $sanitize)
    {
        console.log("IndexController");
        
        var vm = this;
        vm.defaultLogo = $sanitize(CONFIG.defaultLogo);

        // Data
        vm.themes = fuseTheming.themes;

        var token = localStorageService.get('token');
        console.log("=>" + token);
        if(token) {
          $http.defaults.headers.common.Authorization = 'Bearer ' + token;
          console.log("load token: " + token);
        }

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .constant('CONFIG', {
            'title': 'Short Connection',           
            'apiBaseUrl': 'http://app.short-connection.com/api/',
            'apiBaseUrlJson': 'http://app.short-connection.com/api/',
            'apiModules': 'Users,Profiles,Events,Companys,Orders,Reports,Articles,Locations,Documentstates,Photos',
            'defaultLogo': '<span>GT</span>',
            'loginLogo': '<span>GT</span>',
            'device': 'desktop'
        });

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($mdDateLocaleProvider)
    {
        $mdDateLocaleProvider.formatDate = formatDate;

        function formatDate(date) {
            return date ? moment(date).format('YYYY-MM-DD') : '';
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource, $http, CONFIG, localStorageService, md5, $rootScope)
    {
      $http.defaults.useXDomain = true; 
      $http.defaults.headers.common['X-Requested-With'];
      var api = {};

      //GENERIC MODULES
      var apiModules = CONFIG.apiModules.split(",");

      for(var k=0 ; k < apiModules.length; k++) {
        var apiModule = apiModules[k];
        api[apiModule.toLowerCase()] = $resource( CONFIG.apiBaseUrl + apiModule +'/:id',
            {}, { 
                'query':  {method:'GET', isArray:false},
                'delete': {method:'GET', isArray:false, url: CONFIG.apiBaseUrl + apiModule +'/delete/:id'},
            } );
      }

      //ESPECIFIC MODULES
      api.Login = Login;
      api.Logout = Logout;
      return api;

      function Login(username, password, callback) {
          $http.post(CONFIG.apiBaseUrl + 'users/autenticate',
                      { username: username, password: password, device: CONFIG.device })

              .success(function (response) {
                  console.log(response);
                  if (response.token) {
                      localStorageService.set('user_id', response.user.id);
                      localStorageService.set('username', response.user.name);
                      localStorageService.set('logo', response.user.Logo);
                      localStorageService.set('profile', response.user.profile);
                      localStorageService.set('sel_company', response.user.CompanyID);
                      localStorageService.set('rules', response.rules);
                      localStorageService.set('token', response.token);
                      localStorageService.set('companys', response.companys);

                      $rootScope.profile = response.user.profile;
                      callback(true);
                  } else {
                      callback(false);
                  }
              });
      }

      function Logout() {
          localStorageService.clearAll();
          $http.defaults.headers.common.Authorization = '';
      }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages', [
            'app.user', 'app.users','app.calendar', 'app.order', 'app.report',
            'app.events', 'app.event', 'app.orders', 'app.articles', 'app.article', 'app.catalog'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {

      console.log("PagesModule");

    }
})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/auth/auth.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><img \nsrc=\"assets\\images\\backgrounds\\logoshort.png\" width=\"100%\"><div class=\"title\" translate=\"LOGIN.TITLE\">\nLog in to your account</div><form name=\"loginForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input \ntype=\"text\" name=\"username\" ng-model=\"vm.form.username\" placeholder=\"Username\" translate \ntranslate-attr-placeholder=\"LOGIN.USERNAME\" required><div ng-messages=\"loginForm.username.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"LOGIN.ERRORS.USERNAME_REQUIRED\">Username field is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" placeholder=\"Password\" translate translate-attr-placeholder=\"LOGIN.PASSWORD\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><md-checkbox \nclass=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span translate=\"LOGIN.REMEMBER_ME\">Remember Me</span>\n</md-checkbox><a ui-sref=\"app.recover\" class=\"forgot-password md-accent-color\" translate=\"LOGIN.FORGOT_PASSWORD\">\nForgot Password?</a></div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"LOGIN.LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN.LOG_IN\" ng-click=\"vm.login(vm.form.username, vm.form.password)\">LOG IN</md-button>\n</form></div></div></div>");
$templateCache.put("app/recover/recover.html","<div id=\"recover\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"recover-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div ng-if=\"vm.token == \'\'\" id=\"recover-form\" class=\"md-whiteframe-8dp\"><img \nsrc=\"assets\\images\\backgrounds\\logoshort.png\" width=\"100%\"><div class=\"title\" translate=\"RECOVER.TITLE\">\nInsert your e-mail account</div><form name=\"recoverForm\" novalidate><md-input-container class=\"md-block\" md-no-float>\n<input type=\"email\" name=\"email\" ng-model=\"vm.recover.email\" placeholder=\"Email\" translate \ntranslate-attr-placeholder=\"RECOVER.EMAIL\" required><div ng-messages=\"recoverForm.email.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"RECOVER.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"RECOVER\" \nng-disabled=\"recoverForm.$invalid || recoverForm.$pristine\" translate=\"RECOVER.TEXT\" \ntranslate-attr-aria-label=\"RECOVER.TEXT\" ng-click=\"vm.recover(vm.recover.email)\">RECOVER</md-button></form><div \nstyle=\"margin-bottom:10px;cursor:pointer\"><a ng-click=\"vm.token=\'1\'\" class=\"forgot-password md-accent-color\" \ntranslate=\"RECOVER.INSERT_TOKEN\">Set new password with token</a></div><a ui-sref=\"app.auth\" \nclass=\"forgot-password md-accent-color\" translate=\"RECOVER.BACK_TO_LOGIN_PAGE\">Back to Login</a></div><div \nng-if=\"vm.token != \'\'\" id=\"recover-form\" class=\"md-whiteframe-8dp\"><img src=\"assets\\images\\backgrounds\\logoshort.png\" \nwidth=\"100%\"><div class=\"title\" translate=\"RECOVER.PWDTITLE\">Insert your new password</div><form name=\"recoverForm\" \nnovalidate><md-input-container class=\"md-block\" md-no-float><input type=\"text\" name=\"token\" \nng-model=\"vm.recover.token\" placeholder=\"token\" translate translate-attr-placeholder=\"RECOVER.TOKEN\" required><div \nng-messages=\"recoverForm.token.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RECOVER.ERRORS.TOKEN_EMPTY\">Token is empty</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.recover.password\" \nplaceholder=\"Password\" translate translate-attr-placeholder=\"RECOVER.PASSWORD\" required><div \nng-messages=\"recoverForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RECOVER.ERRORS.PASSWORD_EMPTY\">Password is empty</span></div></div></md-input-container><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"SET NEW PASSWORD\" \nng-disabled=\"recoverForm.$invalid || recoverForm.$pristine\" translate=\"RECOVER.TEXTPWD\" \ntranslate-attr-aria-label=\"RECOVER.TEXTPWD\" ng-click=\"vm.definepwd(vm.recover.token,vm.recover.password)\">\nSET NEW PASSWORD</md-button></form><a ui-sref=\"app.auth\" class=\"forgot-password md-accent-color\" \ntranslate=\"RECOVER.BACK_TO_LOGIN_PAGE\">Back to Login</a></div></div></div>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div id=\"content-container\" flex \nlayout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex>\n</md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" ms-scroll \nng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><img \nng-if=\"vm.logo != \'\' && vm.companys.length == 0\" ng-src=\"vm.logo\"><md-select ng-if=\"vm.companys.length > 0\" \nclass=\"h4 md-no-underline\" style=\"color: #FFF !important\" ng-model=\"vm.sel_company\" ng-show=\"vm.companys.length>0\" \nng-change=\"vm.update_company()\"><md-option ng-repeat=\"company in vm.companys\" \nng-selected=\"{{company.id == vm.sel_company}}\" ng-value=\"company.id\">{{company.label==\'*\'?vm.profile:company.label}}\n</md-option></md-select><span ng-if=\"vm.companys.length == 0 && vm.logo==\'\'\" class=\"h4 md-no-underline\" \nstyle=\"color: #FFF !important\">{{vm.sel_company}}</span><md-icon class=\"fold-toggle s18\" \nmd-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar>\n<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/main/pages/article/article.html","<div id=\"e-commerce-product\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ng-click=\"vm.gotoList()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-arrow-left\" style=\"color: black\"></md-icon>\n</md-button><div layout=\"row\" layout-align=\"start center\"><div class=\"product-image\" hide-xs \nng-show=\"vm.record.Imagem\"><img ng-src=\"{{vm.record.Imagem}}\"></div><div layout=\"column\" layout-align=\"start start\">\n<div class=\"h2\" style=\"color: black\">\n{{vm.record ? (vm.record.local ? vm.record.local : vm.recordLabel) : vm.recordLabel }}</div><div style=\"color: black\">\n<span>{{vm.record.BrandID}}</span></div></div></div></div><div></div></div><div class=\"content\"><md-tabs \nmd-dynamic-height><md-tab><md-tab-label><span translate=\"ARTICLE.GENERAL\"></span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.id\"><div layout=\"row\" \nflex=\"100\"><div layout-align=\"start start\" flex=\"40\" ng-show=\"vm.record.Imagem\"><img ng-src=\"{{vm.record.Imagem}}\" \nwidth=\"100%\" onerror=\"angular.element(this).scope().vm.record.Imagem = false\"></div><div layout-align=\"center center\" \nflex=\"100\"><md-input-container class=\"md-block\"><label translate=\"ARTICLES.TABLE_COL_CODE\"></label><input type=\"text\" \nname=\"address\" ng-model=\"vm.record.ArticleID\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"ARTICLES.TABLE_DESCRIPTION\"></label><input type=\"text\" name=\"address\" ng-model=\"vm.record.Description\">\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"ARTICLES.TABLE_FAMILY\"></label><input \ntype=\"text\" name=\"address\" ng-model=\"vm.record.Family\"></md-input-container><md-input-container class=\"md-block\"><label\n translate=\"ARTICLES.TABLE_TYPE\"></label><input type=\"text\" name=\"address\" ng-model=\"vm.record.Type\">\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"ARTICLES.TABLE_BRAND\"></label><input \ntype=\"text\" name=\"address\" ng-model=\"vm.record.BrandID\"></md-input-container><md-input-container class=\"md-block\">\n<label translate=\"ARTICLES.TABLE_STOCK\"></label><input type=\"text\" name=\"address\" \nng-model=\"vm.record.HeadWarehouseStock\"></md-input-container><md-button type=\"submit\" class=\"md-raised md-background\" \nng-click=\"vm.gotoList()\"><span translate=\"ARTICLE.BACK\"></span></md-button></div></div></form></div></md-tab-body>\n</md-tab><md-tab><md-tab-label><span translate=\"ARTICLE.DETAIL\"></span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.id\"><div layout=\"row\" \nflex=\"100\"><div layout-align=\"start start\" flex=\"40\" ng-show=\"vm.record.Imagem\"><img ng-src=\"{{vm.record.Imagem}}\" \nwidth=\"100%\" onerror=\"angular.element(this).scope().vm.record.Imagem = false\"></div><div layout-align=\"center center\" \nflex=\"100\"><md-input-container class=\"md-block\"><label translate=\"ARTICLE.BAR_CODE\"></label><input type=\"text\" \nname=\"address\" ng-model=\"vm.record.DefaultBarcode\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"ARTICLE.OBS\"></label><input type=\"text\" name=\"address\" ng-model=\"vm.record.Observations\">\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"ARTICLE.FIELD1\"></label><input type=\"text\" \nname=\"address\" ng-model=\"vm.record.FreeField01\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"ARTICLE.FIELD2\"></label><input type=\"text\" name=\"address\" ng-model=\"vm.record.FreeField02\">\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"ARTICLE.FIELD3\"></label><input type=\"text\" \nname=\"address\" ng-model=\"vm.record.FreeField03\"></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-background\" ng-click=\"vm.gotoList()\"><span translate=\"ARTICLE.BACK\"></span></md-button></div></div>\n</form></div></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"ARTICLE.LOCATION\"></span></md-tab-label>\n<md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><table datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\" id=\"cb-mychapter-table\" cellspacing=\"0\" width=\"100%\"><thead>\n<tr style=\"background-color: #2d323e; color: #fff\"><th translate=\"ARTICLE.SERIAL\">Nr.Serie</th><th \ntranslate=\"ARTICLE.LOCAL\">Local</th><th translate=\"ARTICLE.STATE\">Estado</th><th translate=\"ARTICLE.NOTES\">Notas</th>\n</tr></thead><tbody><tr ng-repeat=\"prod in vm.locals\"><td>{{prod.SerialNr}}</td><td>{{prod.LocationID}}</td><td>\n{{prod.Status}}</td><td>{{prod.notes}}</td></tr></tbody></table></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/articles/articles-filter.html","<md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'filters-sidenav\')\" aria-label=\"Filter Cards\" translate \ntranslate-attr-aria-label=\"EQUIPMENTS.FILTER\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon><md-tooltip>\n<span translate=\"EQUIPMENTS.FILTER\">Open Filters</span></md-tooltip></md-button><span flex class=\"menu-title\" \ntranslate=\"EQUIPMENTS.FILTER\">Filter</span><md-button ng-if=\"vm.haveFilters()\" ng-click=\"vm.clearFilters()\" \nclass=\"md-icon-button\" aria-label=\"clear filters\"><md-icon md-font-icon=\"icon-filter-remove-outline\"></md-icon>\n<md-tooltip><span translate=\"EQUIPMENTS.CLEAR_FILTER\"></span></md-tooltip></md-button></div></md-toolbar><md-content \nclass=\"\" ms-scroll><md-list ng-cloak><md-card><md-card-content><div layout=\"row\" layout-align=\"start center\">\n<md-input-container flex=\"100\"><label>Client</label><md-select placeholder=\"Utilizador\" ng-model=\"vm.sel_client\" \nmd-on-open=\"vm.loadClients()\" ng-change=\"vm.filterClients()\" class=\"md-no-underline\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTermClient\" type=\"search\" placeholder=\"Search\" \nclass=\"demo-header-searchbox md-text\" ng-keydown=\"vm.updateSearch($event)\"></md-select-header><md-option value=\"0\">\n-- Select --</md-option><md-option ng-value=\"client\" \nng-repeat=\"client in vm.clients | orderBy: \'client\' | filter:searchTermClient\">{{client.client}}</md-option>\n</md-select></md-input-container></div></md-card-content></md-card></md-list></md-content>");
$templateCache.put("app/main/pages/articles/articles.html","<div id=\"e-commerce-orders\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"black-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-account-multiple\"></md-icon><span translate=\"ARTICLES.NAV\">\n</span></div><div class=\"order-count\"><span translate=\"ARTICLES.TOTAL_RECORDS\"></span> <span>{{vm.totalRecords}}</span>\n</div></div><div class=\"search\" layout=\"row\" layout-align=\"end center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" ng-model=\"vm.userFilters.search\" translate translate-attr-placeholder=\"ARTICLES.SEARCH\" flex>\n</div><div class=\"newrecord\" layout=\"row\" layout-align=\"end center\" flex><md-button \nclass=\"md-fab md-primary md-button md-default-theme md-ink-ripple\" id=\"add-contact-button\" ng-click=\"vm.gotoDetail(0)\" \nng-show=\"false\" aria-label=\"add contact\" translate translate-attr-aria-label=\"ARTICLES.ADD_CONTACT\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable hover row-border\" datatable=\"\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\"></table></div></div></div></div>");
$templateCache.put("app/main/pages/catalog/catalog.html","<style>\nmd-card>:not(md-card-content) img, md-card>img {\r\n    height: 150px !important;\r\n  }\r\n  .description {\r\n    align-content: center;\r\n    height: 33px;\r\n    text-align: center;\r\n  }\n</style><div layout=\"row\" layout-align=\"center center\" class=\"layout-row\" style=\"margin: 0px 10px 0 30px\"><div \nflex=\"80\" style=\"align: center\"><md-input-container><label translate=\"CATALOG.FAMILY\"></label><md-select \nng-model=\"vm.pesquisa.Family\"><md-option ng-repeat=\"family in vm.familys\" ng-value=\"family.FamilyID\">\n{{family.Description}}</md-option></md-select></md-input-container><md-input-container><label \ntranslate=\"CATALOG.SUBFAMILIES\"></label><md-select ng-model=\"vm.pesquisa.SubFamily\"><md-option \nng-repeat=\"subfamily in vm.subfamilies\" ng-value=\"subfamily.SubFamily\">{{subfamily.SubFamily}}</md-option></md-select>\n</md-input-container><md-input-container><label translate=\"CATALOG.BRAND\"></label><md-select \nng-model=\"vm.pesquisa.BrandID\"><md-option ng-repeat=\"brand in vm.brands\" ng-value=\"brand.BrandID\">{{brand.BrandID}}\n</md-option></md-select></md-input-container><md-button md-no-ink class=\"md-primary\" ng-click=\"vm.clearFilters()\" \ntranslate=\"CATALOG.RESET\"></md-button></div><div flex=\"30\" layout-align=\"end end\"><md-input-container><label \ntranslate=\"CATALOG.SEARCH\"></label><input ng-model=\"vm.search\" ng-change=\"vm.copyModel()\"></md-input-container></div>\n</div><div layout=\"row\" flex=\"100\" class=\"layout-wrap\"><div ng-repeat=\"article in vm.articles | filter:vm.pesquisa\">\n<md-card class=\"artigo-produto\" style=\"width: 220px\" layout-align=\"center center\"><img \nng-src=\"{{article.Imagem || \'assets/images/ecommerce/no-image-slide.png\'}}\"><div class=\"h5 description\" \nlayout-align=\"none center\">{{article.Description}}</div><md-card-actions layout=\"row\" layout-align=\"end center\">\n<md-button ng-click=\"vm.gotoDetail(article.Codigo)\" translate=\"CATALOG.DETAILS\" aria-label=\"{{article.Description}}\">\n</md-button></md-card-actions></md-card></div></div>");
$templateCache.put("app/main/pages/calendar/calendar.html","<div id=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"header\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" \nlayout=\"row\" layout-align=\"space-between start\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span \nclass=\"logo-text\" translate=\"CALENDAR.CALENDAR\">Calendar</span></div><div class=\"widget-group\" layout=\"row\" flex=\"60\" \nlayout-wrap layout-align=\"end end\"><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"30\" flex-gt-md=\"20\" \nng-if=\"vm.profile == \'aaa\'\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex><div class=\"pt-8 pb-8\" \nlayout=\"column\" layout-align=\"center center\" flex><div class=\"font-weight-500 secondary-text pb-8\" \nstyle=\"text-align:center\" translate=\"CALENDAR.ACTIVE_EVENTS\"></div><div class=\"md-display-1\">{{vm.nrEvents}}</div>\n</div></ms-widget-front></ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"30\" \nflex-gt-md=\"20\" ng-if=\"vm.profile == \'ADMIN\'\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex><div \nclass=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div class=\"font-weight-500 secondary-text pb-8\" \nstyle=\"text-align:center\" translate=\"CALENDAR.EVENTS_WOUT_ORDERS\"></div><div class=\"md-display-1\">\n{{vm.eventossempedidos}}</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"30\" flex-gt-md=\"20\" ng-if=\"vm.profile == \'ADMIN\' || vm.profile == \'OPERATOR\'\"><ms-widget-front \nclass=\"p-16 white-bg\" layout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"font-weight-500 secondary-text pb-8\" style=\"text-align:center\" translate=\"CALENDAR.ORDERS_UPDATING\"></div><div \nclass=\"md-display-1\">{{vm.nrAprovados}}</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"40\" flex-gt-md=\"20\" ng-if=\"vm.profile == \'ADMIN\' || vm.profile == \'CLIENT\'\">\n<ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"column\" \nlayout-align=\"center center\" flex><div class=\"font-weight-500 secondary-text pb-8\" style=\"text-align:center\" \ntranslate=\"CALENDAR.PENDING_ORDERS\"></div><div class=\"md-display-1\">{{vm.nrRegistados}}</div></div></ms-widget-front>\n</ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"40\" flex-gt-md=\"20\" \nng-if=\"vm.profile == \'OPERATOR\'\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex><div class=\"pt-8 pb-8\" \nlayout=\"column\" layout-align=\"center center\" flex><div class=\"font-weight-500 secondary-text pb-8\" \nstyle=\"text-align:center\" translate=\"CALENDAR.PENDING_ANSWER_ORDERS\"></div><div class=\"md-display-1\">\n{{vm.pedidosporresponder}}</div></div></ms-widget-front></ms-widget></div></div><div class=\"header-bottom\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" \naria-label=\"Previous\" translate translate-attr-aria-label=\"CALENDAR.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><div class=\"title\">{{vm.calendarView.title}}</div><md-button \nclass=\"md-icon-button arrow\" ng-click=\"vm.calendar.next()\" aria-label=\"Next\" translate \ntranslate-attr-aria-label=\"CALENDAR.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div>\n</div><div class=\"content\"><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" \ncalendar=\"main\"></div></div></div>");
$templateCache.put("app/main/pages/event/event.html","<div id=\"e-commerce-product\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ng-click=\"vm.gotoList()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-arrow-left\" style=\"color: black\"></md-icon>\n</md-button><div layout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"h2\" style=\"color: black\">{{vm.record ? (vm.record.local ? vm.record.local : vm.recordLabel) : vm.recordLabel }}\n</div><div style=\"color: black\"><span>{{vm.create_user}}</span></div></div></div></div><div></div></div><div \nclass=\"content\"><md-tabs md-dynamic-height><md-tab><md-tab-label><span translate=\"EVENT.BASIC_INFO\"></span>\n</md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form \nname=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\"><input type=\"hidden\" ng-model=\"vm.record.EventID\">\n<md-input-container md-is-error=\"recordForm.event.$invalid && (recordForm.event.$touched || recordForm.$submitted)\" \nclass=\"md-block\"><label translate=\"EVENT.EVENT\"></label><input type=\"text\" name=\"EventDescription\" \nng-model=\"vm.record.EventDescription\" ng-disabled=\"vm.nrPedidos>0\" required><div ng-messages=\"recordForm.event.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"EVENT.REQUIRED\"></span></div></div></md-input-container><div \nlayout-gt-xs=\"row\"><md-datepicker name=\"terminationDate\" ng-disabled=\"vm.nrPedidos>0\" style=\"margin-left:-16px\" \nmd-placeholder=\'{{\"EVENT.STARTDATE\" | translate}}\' ng-model=\"vm.record.StartDate\"></md-datepicker></div><br><div \nlayout-gt-xs=\"row\"><md-datepicker name=\"terminationDate\" ng-disabled=\"vm.nrPedidos>0\" style=\"margin-left:-16px\" \nmd-placeholder=\'{{\"EVENT.ENDDATE\" | translate}}\' ng-model=\"vm.record.EndDate\"></md-datepicker></div><br><div \nlayout-gt-xs=\"row\"><md-checkbox ng-model=\"vm.IsActive\" aria-label=\"Checkbox 1\" translate=\"EVENT.ACTIVE\"></md-checkbox>\n</div><br><md-button type=\"submit\" class=\"md-raised md-background\" ng-click=\"vm.gotoList()\"><span \ntranslate=\"EVENT.BACK\"></span></md-button><md-button type=\"submit\" class=\"md-raised md-background\" \nng-click=\"recordForm.$valid && vm.save(vm.record)\" ng-show=\"vm.checkPerm(\'alterar\')\"><span translate=\"EVENT.SAVE\">\n</span></md-button></form></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/orders/orders-filter.html","<md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'filters-sidenav\')\" aria-label=\"Filter Cards\" translate \ntranslate-attr-aria-label=\"ORDERS.FILTER\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon><md-tooltip><span \ntranslate=\"ORDERS.FILTER\">Open Filters</span></md-tooltip></md-button><span flex class=\"menu-title\" \ntranslate=\"ORDERS.FILTER\">Filter</span><md-button ng-if=\"vm.haveFilters()\" ng-click=\"vm.clearFilters()\" \nclass=\"md-icon-button\" aria-label=\"clear filters\"><md-icon md-font-icon=\"icon-filter-remove-outline\"></md-icon>\n<md-tooltip><span translate=\"ORDERS.CLEAR_FILTER\"></span></md-tooltip></md-button></div></md-toolbar><md-content \nclass=\"\" ms-scroll><md-list ng-cloak><md-card><md-card-content><div layout=\"row\" layout-align=\"start center\">\n<md-input-container flex=\"100\"><label>Evento</label><md-select placeholder=\"Evento\" ng-model=\"vm.sel_event\" \nmd-on-open=\"vm.loadEvents()\" ng-change=\"vm.filterEvents()\" class=\"md-no-underline\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTermEvent\" type=\"search\" placeholder=\"Search\" \nclass=\"demo-header-searchbox md-text\" ng-keydown=\"vm.updateSearch($event)\"></md-select-header><md-option value=\"0\">\n-- Select --</md-option><md-option ng-value=\"event\" \nng-repeat=\"event in vm.events | orderBy: \'event\' | filter:searchTermEvent\">{{event.title}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container flex=\"100\"><label>Estado\n</label><md-select placeholder=\"Estado\" ng-model=\"vm.sel_state\" md-on-open=\"vm.loadStates()\" \nng-change=\"vm.filterStates()\" class=\"md-no-underline\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchTermState\" type=\"search\" placeholder=\"Search\" class=\"demo-header-searchbox md-text\" \nng-keydown=\"vm.updateSearch($event)\"></md-select-header><md-option value=\"0\">-- Select --</md-option><md-option \nng-value=\"state\" ng-repeat=\"state in vm.states | orderBy: \'state\' | filter:searchTermState\">{{state.DocumentStatus}}\n</md-option></md-select></md-input-container></div></md-card-content></md-card></md-list></md-content>");
$templateCache.put("app/main/pages/orders/orders.html","<style>\n.bg_red {\r\n  padding: 0 0 0 0 !important;\r\n  margin: 0 0 0 0 !important;\r\n  margin-right: 2px !important;\r\n  margin-bottom: 2px !important;\r\n  background-color: #d1a900 !important;\r\n}\n</style><div id=\"e-commerce-orders\" class=\"page-layout carded left-sidenav\" layout=\"row\"><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg md-sidenav-right filterNav\" ms-scroll md-component-id=\"filters-sidenav\" \nms-sidenav-helper ng-include=\"\'app/main/pages/orders/orders-filter.html\'\"></md-sidenav><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"black-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-file-document\"></md-icon><span \ntranslate=\"ORDERS.NAV\"></span></div><div class=\"order-count\" ng-hide=\"vm.topfilter==\'\'\"><span>\n{{\'Evento: \' + vm.topfilter}}</span></div><div class=\"order-count\"><span translate=\"ORDERS.TOTAL_RECORDS\"></span> \n<span>{{vm.topfilter==\'\' ? vm.totalRecords : vm.totalRecordsFiltered}}</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"end center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" \nng-model=\"vm.userFilters.search\" translate translate-attr-placeholder=\"ORDERS.SEARCH\" flex></div><div \nclass=\"newrecord\" layout=\"row\" layout-align=\"end center\" flex><md-button \nclass=\"md-fab md-primary md-button md-default-theme md-ink-ripple\" id=\"add-contact-button\" ng-click=\"vm.openReport(0)\" \naria-label=\"add contact\" translate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'filters-sidenav\')\" \naria-label=\"Filter Cards\" translate translate-attr-aria-label=\"ORDERS.FILTER\"><md-icon \nmd-font-icon=\"icon-filter-variant\"></md-icon><md-tooltip><span translate=\"ORDERS.FILTER\">Open Filters</span>\n</md-tooltip></md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable hover row-border\" datatable=\"\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\"></table></div></div></div></div>");
$templateCache.put("app/main/pages/order/order.html","<style>\nmd-input-container.md-default-theme label, \r\n md-input-container.md-default-theme .md-placeholder{\r\n    color:black !important;\r\n}\r\n.md-no-underline span  {\r\n    color: black;\r\n}\r\n.md-datepicker-input[placeholder] {\r\n    color:black;\r\n}\n</style><div id=\"e-commerce-product\" class=\"page-layout simple tabbed\" layout=\"column\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" \nng-click=\"vm.gotoList()\" translate translate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon \nmd-font-icon=\"icon-arrow-left\" style=\"color: black\"></md-icon></md-button><div layout=\"row\" flex=\"100\" \nlayout-align=\"start center\"><div layout=\"column\" flex=\"80\" layout-align=\"start start\"><div class=\"h2\" \nstyle=\"color: black\">{{vm.record ? (vm.record.local ? vm.record.local : vm.recordLabel) : vm.recordLabel }}</div></div>\n<div layout=\"column\" layout-align=\"end center\"><md-button class=\"md-primary md-raised\" \nng-click=\"vm.showCatalogo($event)\" \nng-if=\"vm.record.DocumentStatus != \'Execução\' && vm.record.DocumentStatus != \'Executado\' && vm.profile != \'OPERATOR\'\">\nAdicionar Produto</md-button></div><div layout=\"column\" layout-align=\"end center\"><md-button type=\"submit\" \nclass=\"md-raised md-background\" \nng-if=\"vm.record.DocumentStatus != \'Execução\' && vm.record.DocumentStatus != \'Executado\' && vm.profile != \'OPERATOR\'\" \nng-click=\"vm.save(vm.record)\" \nng-disabled=\"(vm.products.length==0 && vm.lines.length==0) || (vm.s_implementacao!=true && vm.s_entrega!=true && vm.s_levantamento!=true) || vm.loading\">\n<span translate=\"ORDER.SAVE\">SAVE</span></md-button></div><div layout=\"column\" layout-align=\"end center\"><md-button \ntype=\"submit\" \nng-if=\"vm.profile == \'ADMIN\' && vm.record.DocumentID && vm.record.DocumentStatus != \'Execução\' && vm.record.DocumentStatus != \'Executado\' && vm.profile != \'OPERATOR\'\" \nclass=\"md-raised md-background green-500-bg\" ng-click=\"vm.save_aprovar(vm.record)\" \nng-disabled=\"(vm.products.length==0 || !vm.sel_event) && vm.lines.length==0\"><span>Aprovar</span></md-button></div>\n</div></div><div></div></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab><md-tab-label><span \ntranslate=\"ORDER.BASIC_INFO\"></span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div layout=\"row\" layout-align=\"end center\">\n<md-button ng-disabled=\"{{vm.lockinsertlocal}}\" class=\"md-fab md-mini md-primary\" ng-show=\"vm.profile != \'OPERATOR\'\" \nng-click=\"vm.showLocal($event)\"><md-tooltip md-direction=\"left\">{{ \'ORDER.NEW_LOCATION\' | translate }}</md-tooltip>\n<md-icon md-font-icon=\"icon-map-marker\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"center center\">\n<form name=\"recordForm\" layout=\"row\"><div flex=\"33\"><md-card \nng-style=\"{\'height\':\'250px\', \'width\': \'300px\', \'background-color\': !(vm.s_implementacao==true) ? \'#F0F0F0\' : \'#fff\'}\" \nlayout-align=\"center center\"><md-card-title><md-switch ng-disabled=\"{{vm.lockswitch}}\" ng-model=\"vm.s_implementacao\" \naria-label=\"Switch 1\" ng-change=\"vm.changeImplementation()\" style=\"position: relative; top: -30px\">\n{{ \'ORDER.IMPLEMENTATION\' | translate }}</md-switch></md-card-title><md-card-content><div \nclass=\"md-media-lg card-media\"></div></md-card-content></md-card></div><div flex=\"33\" layout-align=\"center center\">\n<md-card md-theme-watch \nng-style=\"{\'height\':\'250px\', \'width\': \'300px\', \'background-color\': !(vm.s_entrega==true) ? \'#F0F0F0\' : \'#fff\'}\" \nlayout-align=\"center center\"><md-card-title><md-switch ng-disabled=\"{{vm.lockswitch}}\" ng-model=\"vm.s_entrega\" \naria-label=\"Switch 1\" ng-change=\"vm.changeEntrega()\">{{ \'ORDER.DELIVERY\' | translate }}</md-switch></md-card-title>\n<md-card-content><div class=\"md-media-lg card-media\"><md-input-container class=\"md-block\"><label \ntranslate=\"ORDER.DELIVERY_LOCATION\"></label><md-select ng-model=\"vm.record.localentrega\" \nng-disabled=\"!(vm.s_entrega==true)\" placeholder=\"Local de Entrega\" class=\"md-no-underline\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTermEntrega\" type=\"search\" placeholder=\"Pesquisa\" \nclass=\"demo-header-searchbox md-text\" ng-keydown=\"vm.updateSearch($event)\"></md-select-header><md-option value=\"\" \nng-show=\"!searchTermEntrega\">Escolha local</md-option><md-option ng-value=\"local.id\" \nng-repeat=\"local in vm.locations | filter: searchTermEntrega\">{{local.label}}</md-option></md-select>\n</md-input-container><md-datepicker name=\"terminationDate\" md-placeholder=\"Data\" ng-model=\"vm.record.dataentrega\" \nng-disabled=\"!(vm.s_entrega==true)\" style=\"margin-left: -15px\"></md-datepicker><md-input-container class=\"md-block\">\n<label translate=\"ORDER.DELIVERY_HOUR\"></label><md-select ng-model=\"vm.record.horaentrega\" \nng-disabled=\"!(vm.s_entrega==true)\" placeholder=\"Hora Prevista\" class=\"md-no-underline\"><md-option value=\"09:00\">Manhã\n</md-option><md-option value=\"14:00\">Tarde</md-option><md-option value=\"19:00\">Antes Fecho</md-option><md-option \nvalue=\"23:00\">Após Fecho</md-option></md-select><div ng-messages=\"recordForm.usertype.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"ORDER.REQUIRED\"></span></div></div></md-input-container></div></md-card-content>\n</md-card></div><div flex=\"33\" layout-align=\"center center\"><md-card \nng-style=\"{\'height\':\'250px\', \'width\': \'300px\', \'background-color\': !(vm.s_levantamento==true) ? \'#F0F0F0\' : \'#fff\'}\" \nlayout-align=\"center center\"><md-card-title><md-switch ng-disabled=\"{{vm.lockswitch}}\" ng-model=\"vm.s_levantamento\" \naria-label=\"Switch 1\" ng-change=\"vm.changeLevantamento()\">{{ \'ORDER.PICKUP\' | translate }}</md-switch></md-card-title>\n<md-card-content><div class=\"md-media-lg card-media\"><md-input-container class=\"md-block\"><label \ntranslate=\"ORDER.PICKUP_PLACE\"></label><md-select ng-model=\"vm.record.locallevantamento\" \nng-disabled=\"!(vm.s_levantamento==true)\" placeholder=\"{{ \'ORDER.PICKUP_PLACE\' | translate }}\" class=\"md-no-underline\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"searchTermLevantamento\" type=\"search\" \nplaceholder=\"Pesquisa\" class=\"demo-header-searchbox md-text\" ng-keydown=\"vm.updateSearch($event)\"></md-select-header>\n<md-option value=\"\" ng-show=\"!searchTermLevantamento\" translate=\"ORDER.CHOOSE_LOCATION\"></md-option><md-option \nng-value=\"local.id\" ng-repeat=\"local in vm.locations | filter: searchTermLevantamento\">{{local.label}}</md-option>\n</md-select></md-input-container><md-datepicker name=\"terminationDate\" md-placeholder=\'{{ \"ORDER.DATE\" | translate }}\' \nng-model=\"vm.record.datalevantamento\" ng-disabled=\"!(vm.s_levantamento==true)\" style=\"margin-left: -15px\">\n</md-datepicker><md-input-container class=\"md-block\"><label translate=\"ORDER.DELIVERY_HOUR\"></label><md-select \nng-model=\"vm.record.horalevantamento\" ng-disabled=\"!(vm.s_levantamento==true)\" placeholder=\"Hora Prevista\" \nclass=\"md-no-underline\"><md-option value=\"09:00\">Manhã</md-option><md-option value=\"14:00\">Tarde</md-option><md-option \nvalue=\"19:00\">Antes Fecho</md-option><md-option value=\"23:00\">Após Fecho</md-option></md-select><div \nng-messages=\"recordForm.usertype.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ORDER.REQUIRED\">\n</span></div></div></md-input-container></div></md-card-content></md-card></div></form></div><div layout=\"row\"><div \nflex=\"50\"><md-input-container class=\"md-block\"><label translate=\"ORDER.CONTACT\"></label><input type=\"text\" \nng-model=\"vm.record.contacto\"><div ng-messages=\"recordForm.usertype.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"ORDER.REQUIRED\"></span></div></div></md-input-container></div><div flex=\"50\"><md-input-container \nclass=\"md-block\"><label translate=\"ORDER.NOTES\"></label><input type=\"text\" name=\"notes\" ng-model=\"vm.record.notes\"><div\n ng-messages=\"recordForm.notes.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ORDER.REQUIRED\"></span>\n</div></div></md-input-container></div></div><div layout=\"column\" flex><table datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-column-defs=\"vm.dtColumnDefs\" id=\"cb-mychapter-table\" cellspacing=\"0\" width=\"100%\"><thead><tr \nstyle=\"background-color: #2d323e; color: #fff\"><th>{{ \'ORDER.CODE\' | translate }}</th><th>\n{{ \'ORDER.PRODUCT\' | translate }}</th><th>{{ \'ORDER.QUANTITY\' | translate }}</th><th>{{ \'ORDER.SERIAL\' | translate }}\n</th><th></th></tr></thead><tbody><tr ng-repeat=\"prod in vm.products\"><td>{{prod.Codigo}}</td><td>{{prod.Description}}\n</td><td><input ng-model=\"prod.qtd\" type=\"number\" step=\"1\" style=\"width: 50px\"></td><td>{{prod.sn}}</td><td><div \nclass=\"buttons\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" id=\"del_btn\" \nng-click=\"vm.deleteConfirm(prod)\"><md-icon md-font-icon=\"icon-close-circle-outline\"></md-icon></md-button></div></td>\n</tr></tbody></table></div></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/events/events-filter.html","<md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'filters-sidenav\')\" aria-label=\"Filter Cards\" translate \ntranslate-attr-aria-label=\"EVENTS.FILTER\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon><md-tooltip><span \ntranslate=\"EVENTS.FILTER\">Open Filters</span></md-tooltip></md-button><span flex class=\"menu-title\" \ntranslate=\"EVENTS.FILTER\">Filter</span><md-button ng-if=\"vm.haveFilters()\" ng-click=\"vm.clearFilters()\" \nclass=\"md-icon-button\" aria-label=\"clear filters\"><md-icon md-font-icon=\"icon-filter-remove-outline\"></md-icon>\n<md-tooltip><span translate=\"EVENTS.CLEAR_FILTER\"></span></md-tooltip></md-button></div></md-toolbar><md-content \nclass=\"\" ms-scroll><md-list ng-cloak><md-card><md-card-content><div layout=\"row\" layout-align=\"start center\">\n<md-input-container flex=\"100\"><label>Client</label><md-select placeholder=\"Client\" ng-model=\"vm.sel_client\" \nmd-on-open=\"vm.loadClients()\" ng-change=\"vm.filterClients()\" class=\"md-no-underline\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTermClient\" type=\"search\" placeholder=\"Search\" \nclass=\"demo-header-searchbox md-text\" ng-keydown=\"vm.updateSearch($event)\"></md-select-header><md-option value=\"0\">\n-- Select --</md-option><md-option ng-value=\"client\" \nng-repeat=\"client in vm.clients | orderBy: \'client\' | filter:searchTermClient\">{{client.client}}</md-option>\n</md-select></md-input-container></div></md-card-content></md-card></md-list></md-content>");
$templateCache.put("app/main/pages/events/events.html","<style>\n.bg_red {\r\n  padding: 0 0 0 0 !important;\r\n  margin: 0 0 0 0 !important;\r\n  margin-right: 2px !important;\r\n  margin-bottom: 2px !important;\r\n  background-color: #d1a900 !important;\r\n}\n</style><div id=\"e-commerce-orders\" class=\"page-layout carded left-sidenav\" layout=\"row\"><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg md-sidenav-right filterNav\" ms-scroll md-component-id=\"filters-sidenav\" \nms-sidenav-helper ng-include=\"\'app/main/pages/events/events-filter.html\'\"></md-sidenav><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"black-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-calendar-clock\"></md-icon><span \ntranslate=\"EVENTS.NAV\"></span></div><div class=\"order-count\" ng-hide=\"vm.topfilter==\'\'\"><span>{{vm.topfilter}}</span>\n</div><div class=\"order-count\"><span translate=\"EVENTS.TOTAL_RECORDS\"></span> <span>\n{{vm.topfilter==\'\' ? vm.totalRecords : vm.totalRecordsFiltered}}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"end center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" \nng-model=\"vm.userFilters.search\" translate translate-attr-placeholder=\"EVENTS.SEARCH\" flex></div><div \nclass=\"newrecord\" layout=\"row\" layout-align=\"end center\" flex><md-button \nclass=\"md-fab md-primary md-button md-default-theme md-ink-ripple\" id=\"add-contact-button\" ng-click=\"vm.gotoDetail(0)\" \nng-disabled=\"vm.sel_company ==\'*\'\" ng-show=\"vm.checkPerm(\'criar\')\" aria-label=\"add contact\" translate \ntranslate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div>\n<div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable hover row-border\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"></table></div></div></div></div>");
$templateCache.put("app/main/pages/user/user.html","<div id=\"e-commerce-product\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ng-click=\"vm.gotoList()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-arrow-left\" style=\"color:black\"></md-icon>\n</md-button><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"h2\" style=\"color: black\">\n{{vm.record ? (vm.record.DisplayName ? vm.record.DisplayName : vm.recordLabel) : vm.recordLabel }}</div></div></div>\n</div><div></div></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab><md-tab-label><span \ntranslate=\"USER.BASIC_INFO\"></span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.id\"><md-input-container \nclass=\"md-block\"><label translate=\"USER.NAME\"></label><input type=\"text\" name=\"name\" ng-model=\"vm.record.DisplayName\" \nrequired><div ng-messages=\"recordForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"USER.REQUIRED\"></span></div></div></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"USER.INITIALS\"></label><input type=\"text\" name=\"initials\" ng-model=\"vm.record.Initials\"><div \nng-messages=\"recordForm.initials.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"USER.REQUIRED\">\n</span></div></div></md-input-container><md-input-container class=\"md-block\"><label translate=\"USER.EMAIL\"></label>\n<input type=\"text\" name=\"email\" ng-model=\"vm.record.Email\" required><div ng-messages=\"recordForm.email.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"USER.REQUIRED\"></span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"USER.USERNAME\"></label><input type=\"text\" name=\"username\" \nng-model=\"vm.record.Login\" required><div ng-messages=\"recordForm.username.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"USER.REQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"USER.PASSWORD\"></label><input type=\"password\" name=\"password\" \nng-model=\"vm.record.Password\" required><div ng-messages=\"recordForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"USER.REQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"USER.PROFILE\"></label><md-select name=\"ProfileID\" ng-model=\"vm.record.ProfileID\" \nstyle=\"min-width: 200px\"><md-option ng-selected=\"vm.record.ProfileID == profile.id\" ng-value=\"profile.id\" \nng-repeat=\"profile in vm.profiles\">{{profile.label}}</md-option></md-select><div \nng-messages=\"recordForm.ProfileID.$error\" \nng-show=\"!(recordForm.ProfileID.$viewValue > 0) && (recordForm.$submitted || recordForm.ProfileID.$touched || recordForm.ProfileID.$dirty)\">\n<div ng-message=\"required\"><span translate=\"USER.REQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"md-block\" style=\"margin-top: 40px\"><label translate=\"USER.COMPANY\"></label><md-select name=\"CompanyId\" \nng-model=\"vm.record.CompanyId\" style=\"min-width: 200px\"><md-option ng-selected=\"vm.record.CompanyId == company.id\" \nng-value=\"company.id\" ng-repeat=\"company in vm.companys\">{{company.label}}</md-option></md-select><div \nng-messages=\"recordForm.ProfileID.$error\" \nng-show=\"!(recordForm.ProfileID.$viewValue > 0) && (recordForm.$submitted || recordForm.ProfileID.$touched || recordForm.ProfileID.$dirty)\">\n<div ng-message=\"required\"><span translate=\"USER.REQUIRED\"></span></div></div></md-input-container><md-button \ntype=\"submit\" class=\"md-raised md-background\" ng-click=\"vm.gotoList()\"><span translate=\"USER.BACK\">BACK</span>\n</md-button><md-button type=\"submit\" class=\"md-raised md-background\" \nng-click=\"recordForm.$valid && vm.save(vm.record)\" ng-show=\"vm.checkPerm(\'alterar\')\"><span translate=\"USER.SAVE\">SAVE\n</span></md-button></form></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/report/report.html","<div id=\"e-commerce-product\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ng-click=\"vm.gotoList()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-arrow-left\" style=\"color: black\"></md-icon>\n</md-button><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div layout=\"column\" flex=\"80\" \nlayout-align=\"start start\"><div class=\"h2\" style=\"color: black\">\n{{vm.record ? (vm.record.local ? vm.record.local : vm.recordLabel) : vm.recordLabel }}</div></div><div layout=\"column\" \nlayout-align=\"end center\"><md-button type=\"submit\" \nng-if=\"vm.profile == \'ADMIN\' && vm.estado == \'Atualização\' && vm.respostas\" \nclass=\"md-raised md-background green-500-bg\" ng-click=\"vm.save_aprovar(vm.record)\"><span>Aprovar</span></md-button>\n</div><div layout=\"column\" layout-align=\"end center\"><md-button type=\"submit\" \nng-if=\"(vm.profile == \'ADMIN\' && vm.estado != \'Executado\') || (vm.profile != \'ADMIN\'  && vm.estado != \'Executado\' && vm.report_user_id.CreateUser == vm.user_id)\" \nclass=\"md-raised md-background red-500-bg\" ng-click=\"vm.delete_report(vm.record)\"><span>Apagar</span></md-button></div>\n</div></div><div></div></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab><md-tab-label><span \ntranslate=\"REPORT.BASIC_INFO\">{{vm.report_status}}</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.id\"><div \nng-repeat=\"pergunta in vm.perguntas\"><md-input-container class=\"md-block\"><label>{{pergunta.Description}}</label><input\n type=\"text\" name=\"address\" ng-model=\"vm.record[vm.getRespostaID(pergunta.Description)]\" \nng-if=\"pergunta.DataType==\'TEXTBOX\'\"><md-select ng-model=\"vm.record[vm.getRespostaID(pergunta.Description)]\" \nclass=\"md-no-underline\" ng-change=\"vm.checkReason(pergunta)\" ng-if=\"pergunta.DataType==\'COMBOBOX\'\"><md-option \nvalue=\"0\">-- Select --</md-option><md-option ng-value=\"opcao\" \nng-selected=\"vm.getResposta(pergunta.Description) == -1 ? pergunta.DefaultValue == opcao : vm.getResposta(pergunta.Description) == opcao\" \nng-repeat=\"opcao in pergunta.ListValues.split(\';\')\">{{opcao}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" \nng-show=\"pergunta.AskReason == 1 && pergunta.ReasonTrigger.localeCompare(vm.record[vm.getRespostaID(pergunta.Description)]) == 1\">\n<label>Razão</label><textarea style=\"background-color: peachpuff\" \nng-model=\"vm.record[\'reason_\' +vm.getRespostaID(pergunta.Description)]\" rows=\"2\" md-select-on-focus></textarea>\n</md-input-container></div><md-button type=\"submit\" class=\"md-raised md-background\" ng-click=\"vm.gotoList()\"><span \ntranslate=\"REPORT.BACK\">BACK</span></md-button><md-button type=\"submit\" class=\"md-raised md-background\" \nng-click=\"(recordForm.$valid && vm.save(vm.record))\" \nng-if=\"((!vm.respostas || vm.respostas.length == 0) && vm.report_status != \'Executado\' ) || ((vm.report_user_id==vm.user_id || vm.profile ==\'ADMIN\' ) && vm.report_status != \'Executado\' )\">\n<span translate=\"REPORT.SAVE\">SAVE</span></md-button></form></div></md-tab-body></md-tab><md-tab><md-tab-label><span>\nFotografias</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div id=\"product-image-uploader\" \nflow-init=\"{target: \'/upload\'}\" flow-files-submitted=\"$flow.upload()\" flow-file-success=\"$file.msg = $message\"><div \nlayout=\"row\" layout-align=\"start start\" layout-wrap><div ng-repeat=\"image in vm.images\" ng-switch=\"image.type\"><div \nclass=\"product-image uploading\" ng-switch-when=\"uploading\" layout=\"row\" layout-align=\"center center\"><img \nclass=\"media\" flow-img=\"image.file\"></div><div layout=\"column\" class=\"product-image\"><div flex><img class=\"media\" \nng-src=\"{{image.Photo}}\" width=\"200\" style=\"padding: 5px\" ng-click=\"vm.showPhoto($event, image)\"></div><div flex><h5 \nalign=\"center\">{{image.Description}}<md-button class=\"md-icon-button\" ng-click=\"vm.deletePhoto(image.PhotoID)\" \naria-label=\"Filter Cards\" translate translate-attr-aria-label=\"ORDERS.FILTER\"><md-icon style=\"color:red;font:bold\" \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip><span>Apagar imagem</span></md-tooltip></md-button></h5></div></div>\n</div></div><div class=\"upload-button\" layout=\"column\" layout-align=\"center center\"><md-input-container><label>\nDescrição</label><input ng-model=\"vm.desc\"></md-input-container><button class=\"md-button md-raised md-accent\" \ntype=\"file\" ng-disabled=\"!vm.desc\" ngf-select=\"vm.uploadFiles($file, $invalidFiles)\" accept=\"image/*\">Upload</button>\n<md-progress-linear ng-if=\"vm.uploadpercentagem!=100\" md-mode=\"determinate\" value=\"{{vm.uploadpercentagem}}\">\n</md-progress-linear></div></div></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/users/users-filter.html","<md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'filters-sidenav\')\" aria-label=\"Filter Cards\" translate \ntranslate-attr-aria-label=\"USERS.FILTER\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon><md-tooltip><span \ntranslate=\"USERS.FILTER\">Open Filters</span></md-tooltip></md-button><span flex class=\"menu-title\" \ntranslate=\"USERS.FILTER\">Filter</span><md-button ng-if=\"vm.haveFilters()\" ng-click=\"vm.clearFilters()\" \nclass=\"md-icon-button\" aria-label=\"clear filters\"><md-icon md-font-icon=\"icon-filter-remove-outline\"></md-icon>\n<md-tooltip><span translate=\"EQUIPMENTS.CLEAR_FILTER\"></span></md-tooltip></md-button></div></md-toolbar><md-content \nclass=\"\" ms-scroll><md-list ng-cloak><md-card><md-card-content><div layout=\"row\" layout-align=\"start center\">\n<md-input-container flex=\"100\"><label>Perfil</label><md-select placeholder=\"Perfil\" ng-model=\"vm.sel_profile\" \nmd-on-open=\"vm.loadProfiles()\" ng-change=\"vm.filterProfiles()\" class=\"md-no-underline\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTermProfile\" type=\"search\" placeholder=\"Search\" \nclass=\"demo-header-searchbox md-text\" ng-keydown=\"vm.updateSearch($event)\"></md-select-header><md-option value=\"0\">\n-- Select --</md-option><md-option ng-value=\"profile\" \nng-repeat=\"profile in vm.profiles | orderBy: \'client\' | filter:searchTermProfile\">{{profile.label}}</md-option>\n</md-select></md-input-container></div></md-card-content></md-card></md-list></md-content>");
$templateCache.put("app/main/pages/users/users.html","<style>\n.bg_red {\r\n  padding: 0 0 0 0 !important;\r\n  margin: 0 0 0 0 !important;\r\n  margin-right: 2px !important;\r\n  margin-bottom: 2px !important;\r\n  background-color: #d1a900 !important;\r\n}\n</style><div id=\"e-commerce-orders\" class=\"page-layout carded left-sidenav\" layout=\"row\"><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg md-sidenav-right filterNav\" ms-scroll md-component-id=\"filters-sidenav\" \nms-sidenav-helper ng-include=\"\'app/main/pages/users/users-filter.html\'\"></md-sidenav><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"black-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-account-key\"></md-icon><span translate=\"USERS.NAV\"></span>\n</div><div class=\"order-count\" ng-hide=\"vm.topfilter==\'\'\"><span>{{vm.topfilter}}</span></div><div class=\"order-count\">\n<span translate=\"USERS.TOTAL_RECORDS\"></span> <span>{{vm.topfilter==\'\' ? vm.totalRecords : vm.totalRecordsFiltered}}\n</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"end center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" ng-model=\"vm.userFilters.search\" translate \ntranslate-attr-placeholder=\"USERS.SEARCH\" flex></div><div class=\"newrecord\" layout=\"row\" layout-align=\"end center\" \nflex><md-button class=\"md-fab md-primary md-button md-default-theme md-ink-ripple\" id=\"add-contact-button\" \nng-click=\"vm.gotoDetail(0)\" ng-show=\"vm.checkPerm(\'alterar\')\" aria-label=\"add contact\" translate \ntranslate-attr-aria-label=\"USERS.ADD_CONTACT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'filters-sidenav\')\" aria-label=\"Filter Cards\" translate \ntranslate-attr-aria-label=\"USERS.FILTER\"><md-icon md-font-icon=\"icon-filter-variant\"></md-icon><md-tooltip><span \ntranslate=\"USERS.FILTER\">Open Filters</span></md-tooltip></md-button></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable hover row-border\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"></table></div></div></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular><md-menu-bar \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide \nshow-gt-sm>{{vm.username}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div>\n</md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n</div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\r\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\r\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\r\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/main/pages/articles/sidenav/equipments-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-account-multiple\"></md-icon>&nbsp; <span translate=\"EQUIPMENTS.MODULE\"></span></div><div \nclass=\"product-count secondary-text\"><span translate=\"EQUIPMENTS.TOTAL_RECORDS\"></span> <span>{{vm.total}}</span></div>\n</div><div class=\"add-task-button\"><md-button class=\"md-raised\" ng-click=\"vm.openTaskDialog($event)\" \naria-label=\"ADD TASK\" translate=\"EQUIPMENTS.NEW\" translate-attr-aria-label=\"EQUIPMENTS.NEW\">NOVO CLIENTE</md-button>\n</div></div><md-content class=\"content\" flex ms-scroll><div class=\"navigation-simple\" layout=\"column\"><md-button \nclass=\"item\" aria-label=\"All Tasks\" translate translate-attr-aria-label=\"TODO.ALL_TASKS\" \nng-class=\"{\'selected\':vm.showAllClients}\" ng-click=\"vm.resetFilters()\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-view-headline\" class=\"s16\"></md-icon><span class=\"title\" \ntranslate=\"EQUIPMENTS.ALL_RECORDS\">All Tasks</span></div></md-button><div class=\"item subheader\" \ntranslate=\"EQUIPMENTS.FILTER\">Estados de Cliente</div><md-button class=\"tag item\" \naria-label=\"tag {{clientstate.label}}\" ng-repeat=\"clientstate in vm.clientstates\" \nng-click=\"vm.toggleClientFilter(clientstate)\" ng-class=\"{\'selected\':vm.isClientFilterExists(clientstate)}\"><md-icon \nmd-font-icon=\"icon-label\" class=\"s16\" ng-style=\"{\'color\' : clientstate.color}\"></md-icon><span class=\"title\">\n{{clientstate.label}}</span></md-button></div></md-content>");
$templateCache.put("app/main/pages/orders/sidenav/equipments-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-account-multiple\"></md-icon>&nbsp; <span translate=\"EQUIPMENTS.MODULE\"></span></div><div \nclass=\"product-count secondary-text\"><span translate=\"EQUIPMENTS.TOTAL_RECORDS\"></span> <span>{{vm.total}}</span></div>\n</div><div class=\"add-task-button\"><md-button class=\"md-raised\" ng-click=\"vm.openTaskDialog($event)\" \naria-label=\"ADD TASK\" translate=\"EQUIPMENTS.NEW\" translate-attr-aria-label=\"EQUIPMENTS.NEW\">NOVO CLIENTE</md-button>\n</div></div><md-content class=\"content\" flex ms-scroll><div class=\"navigation-simple\" layout=\"column\"><md-button \nclass=\"item\" aria-label=\"All Tasks\" translate translate-attr-aria-label=\"TODO.ALL_TASKS\" \nng-class=\"{\'selected\':vm.showAllClients}\" ng-click=\"vm.resetFilters()\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-view-headline\" class=\"s16\"></md-icon><span class=\"title\" \ntranslate=\"EQUIPMENTS.ALL_RECORDS\">All Tasks</span></div></md-button><div class=\"item subheader\" \ntranslate=\"EQUIPMENTS.FILTER\">Estados de Cliente</div><md-button class=\"tag item\" \naria-label=\"tag {{clientstate.label}}\" ng-repeat=\"clientstate in vm.clientstates\" \nng-click=\"vm.toggleClientFilter(clientstate)\" ng-class=\"{\'selected\':vm.isClientFilterExists(clientstate)}\"><md-icon \nmd-font-icon=\"icon-label\" class=\"s16\" ng-style=\"{\'color\' : clientstate.color}\"></md-icon><span class=\"title\">\n{{clientstate.label}}</span></md-button></div></md-content>");
$templateCache.put("app/main/pages/order/dialog/catalogo.tmpl.html","<style>\nmd-card>:not(md-card-content) img, md-card>img {\r\n    height: 150px !important;\r\n  }\r\n  .description {\r\n    align-content: center;\r\n    height: 33px;\r\n    text-align: center;\r\n  }\n</style><md-dialog flex=\"80\" style=\"height: 80%\"><form ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ORDER.CATALOG\"></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"center center\" \nstyle=\"margin-top: -20px\"><div flex=\"80\" style=\"align: center\"><md-input-container><label translate=\"ORDER.FAMILY\">\n</label><md-select ng-model=\"pesquisa.Family\"><md-option ng-repeat=\"family in familys\" ng-value=\"family.FamilyID\">\n{{family.Description}}</md-option></md-select></md-input-container><md-input-container><label \ntranslate=\"ORDER.SUBFAMILIES\"></label><md-select ng-model=\"pesquisa.SubFamily\"><md-option \nng-repeat=\"subfamily in subfamilies\" ng-value=\"subfamily.SubFamily\">{{subfamily.SubFamily}}</md-option></md-select>\n</md-input-container><md-input-container><label translate=\"ORDER.BRAND\"></label><md-select ng-model=\"pesquisa.BrandID\">\n<md-option ng-repeat=\"brand in brands\" ng-value=\"brand.BrandID\">{{brand.BrandID}}</md-option></md-select>\n</md-input-container><md-button md-no-ink class=\"md-primary\" ng-click=\"clearFilters()\" translate=\"ORDER.RESET\">Limpar\n</md-button></div><div flex=\"30\" layout-align=\"end end\"><md-input-container><label translate=\"ORDER.SEARCH\"></label>\n<input ng-model=\"search\" ng-change=\"copyModel()\"></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nclass=\"layout-wrap\"><div layout=\"column\" ng-repeat=\"article in articles | filter:pesquisa\"><md-card \nstyle=\"width: 220px\" layout-align=\"center center\"><img \nng-src=\"{{article.Imagem || \'assets/images/ecommerce/no-image-slide.png\'}}\" width=\"50\" height=\"30\"><div \nclass=\"h5 description\" layout-align=\"center center\">{{article.Description}}</div><md-card-actions layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"add(article.Codigo)\" translate=\"ORDER.ADD\"></md-button>\n</md-card-actions></md-card></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/pages/order/dialog/local.tmpl.html","<md-dialog style=\"width: 500px\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"ORDER.ADD_LOCATION\"></h2><span\n flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-content layout-padding><form name=\"projectForm\">\n<md-input-container class=\"md-block\"><label translate=\"ORDER.ADD_DESCRIPTION\"></label><input \nng-model=\"record.Designacao\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"ORDER.ADD_STREET\"></label><input ng-model=\"record.AddressLine1\"></md-input-container><div layout=\"row\">\n<md-input-container flex=\"25\"><label translate=\"ORDER.ADD_POSTALCODE\"></label><input ng-model=\"record.POBox\">\n</md-input-container><md-input-container flex=\"75\"><label translate=\"ORDER.ADD_LOCAL\"></label><input \nng-model=\"record.Locality\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"50\"><label \ntranslate=\"ORDER.ADD_EMAIL\"></label><input ng-model=\"record.Email\"></md-input-container><md-input-container flex=\"50\">\n<label translate=\"ORDER.ADD_CONTACT\"></label><input ng-model=\"record.Contact\"></md-input-container></div><div \nlayout=\"row\"><md-input-container flex=\"50\"><label translate=\"ORDER.ADD_PHONE\"></label><input ng-model=\"record.Phone\">\n</md-input-container><md-input-container flex=\"50\"><label translate=\"ORDER.ADD_MOBILE\"></label><input \nng-model=\"record.MobilePhone\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"50\"><label \ntranslate=\"ORDER.ADD_FAX\"></label><input ng-model=\"record.FaxNumber\"></md-input-container><md-input-container \nflex=\"50\"><label translate=\"ORDER.ADD_COUNTRY\"></label><md-select ng-model=\"record.CountryID\"><md-option \nng-repeat=\"country in countrys\" ng-selected=\"country.CountryID==\'PT\'\" ng-value=\"country.CountryID\">\n{{country.Description}}</md-option></md-select></md-input-container></div><md-input-container class=\"md-block\"><label \ntranslate=\"ORDER.ADD_OBS\"></label><input ng-model=\"record.Observation\"></md-input-container><div layout=\"row\">\n<md-button type=\"submit\" class=\"md-raised md-background\" ng-click=\"save(record)\"><span translate=\"ORDER.SAVE\"></span>\n</md-button></div></form></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/pages/events/sidenav/equipments-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-account-multiple\"></md-icon>&nbsp; <span translate=\"EQUIPMENTS.MODULE\"></span></div><div \nclass=\"product-count secondary-text\"><span translate=\"EQUIPMENTS.TOTAL_RECORDS\"></span> <span>{{vm.total}}</span></div>\n</div><div class=\"add-task-button\"><md-button class=\"md-raised\" ng-click=\"vm.openTaskDialog($event)\" \naria-label=\"ADD TASK\" translate=\"EQUIPMENTS.NEW\" translate-attr-aria-label=\"EQUIPMENTS.NEW\">NOVO CLIENTE</md-button>\n</div></div><md-content class=\"content\" flex ms-scroll><div class=\"navigation-simple\" layout=\"column\"><md-button \nclass=\"item\" aria-label=\"All Tasks\" translate translate-attr-aria-label=\"TODO.ALL_TASKS\" \nng-class=\"{\'selected\':vm.showAllClients}\" ng-click=\"vm.resetFilters()\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-view-headline\" class=\"s16\"></md-icon><span class=\"title\" \ntranslate=\"EQUIPMENTS.ALL_RECORDS\">All Tasks</span></div></md-button><div class=\"item subheader\" \ntranslate=\"EQUIPMENTS.FILTER\">Estados de Cliente</div><md-button class=\"tag item\" \naria-label=\"tag {{clientstate.label}}\" ng-repeat=\"clientstate in vm.clientstates\" \nng-click=\"vm.toggleClientFilter(clientstate)\" ng-class=\"{\'selected\':vm.isClientFilterExists(clientstate)}\"><md-icon \nmd-font-icon=\"icon-label\" class=\"s16\" ng-style=\"{\'color\' : clientstate.color}\"></md-icon><span class=\"title\">\n{{clientstate.label}}</span></md-button></div></md-content>");
$templateCache.put("app/main/pages/report/dialog/photo.tmpl.html","<md-dialog aria-label=\"Mango (Fruit)\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{imagem.Description}}</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" style=\"margin-top: -20px\"><div \nlayout=\"row\" layout-align=\"center center\"><img ng-src=\"{{imagem.Photo}}\"></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/pages/users/sidenav/equipments-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-account-multiple\"></md-icon>&nbsp; <span translate=\"EQUIPMENTS.MODULE\"></span></div><div \nclass=\"product-count secondary-text\"><span translate=\"EQUIPMENTS.TOTAL_RECORDS\"></span> <span>{{vm.total}}</span></div>\n</div><div class=\"add-task-button\"><md-button class=\"md-raised\" ng-click=\"vm.openTaskDialog($event)\" \naria-label=\"ADD TASK\" translate=\"EQUIPMENTS.NEW\" translate-attr-aria-label=\"EQUIPMENTS.NEW\">NOVO CLIENTE</md-button>\n</div></div><md-content class=\"content\" flex ms-scroll><div class=\"navigation-simple\" layout=\"column\"><md-button \nclass=\"item\" aria-label=\"All Tasks\" translate translate-attr-aria-label=\"TODO.ALL_TASKS\" \nng-class=\"{\'selected\':vm.showAllClients}\" ng-click=\"vm.resetFilters()\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-view-headline\" class=\"s16\"></md-icon><span class=\"title\" \ntranslate=\"EQUIPMENTS.ALL_RECORDS\">All Tasks</span></div></md-button><div class=\"item subheader\" \ntranslate=\"EQUIPMENTS.FILTER\">Estados de Cliente</div><md-button class=\"tag item\" \naria-label=\"tag {{clientstate.label}}\" ng-repeat=\"clientstate in vm.clientstates\" \nng-click=\"vm.toggleClientFilter(clientstate)\" ng-class=\"{\'selected\':vm.isClientFilterExists(clientstate)}\"><md-icon \nmd-font-icon=\"icon-label\" class=\"s16\" ng-style=\"{\'color\' : clientstate.color}\"></md-icon><span class=\"title\">\n{{clientstate.label}}</span></md-button></div></md-content>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/pages/calendar/dialogs/event-detail/event-detail-dialog.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{vm.calendarEvent.title}}</span> <span flex></span><md-button \nclass=\"edit-event-button md-fab md-warn\" ng-click=\"vm.editEvent(vm.calendarEvent)\" aria-label=\"Edit event\" translate \ntranslate-attr-aria-label=\"CALENDAR.EDIT_EVENT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"event-details\" layout=\"column\"><div class=\"event-detail-row\" \nlayout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-clock\"></md-icon><div layout=\"column\" flex><span \nclass=\"h4\">{{vm.calendarEvent.start.format(\'MMMM Do YYYY, h:mm:ss a\')}} <span ng-if=\"vm.calendarEvent.end\">-</span>\n {{vm.calendarEvent.end.format(\'MMMM Do YYYY, h:mm:ss a\')}}</span> <span class=\"secondary-text\">\n{{vm.calendarEvent.repeat || \'Does not repeat\'}}</span></div></div><div class=\"event-detail-row\" layout=\"row\" \nlayout-align=\"start start\"><md-icon md-font-icon=\"icon-bell-ring-outline\"></md-icon><div layout=\"column\" flex><span \nclass=\"h4\" translate=\"CALENDAR.30_MIN_BEFORE\">30 minutes before</span> <span class=\"h4\" \ntranslate=\"CALENDAR.15_MIN_BEFORE\">15 minutes before</span> <span class=\"h4\" translate=\"CALENDAR.30_MIN_LATER\">\n30 minutes later</span></div></div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><md-icon \nmd-font-icon=\"icon-map-marker\"></md-icon><div layout=\"column\" flex><span class=\"h4\">Istanbul, Turkey</span></div></div>\n<div class=\"event-detail-row\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account\"></md-icon>\n<div layout=\"row\" flex><img src=\"assets/images/avatars/alice.jpg\" class=\"avatar\" alt=\"alice\"> <img \nsrc=\"assets/images/avatars/joyce.jpg\" class=\"avatar\" alt=\"joyce\"> <img src=\"assets/images/avatars/vincent.jpg\" \nclass=\"avatar\" alt=\"vincent\"></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/pages/calendar/dialogs/event-form/event-form-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><label translate=\"CALENDAR.TITLE\">Title</label><input name=\"title\" ng-model=\"vm.calendarEvent.title\" \nrequired md-autofocus><div ng-messages=\"eventForm.title.$error\" ng-show=\"eventForm.title.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"CALENDAR.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div>\n</md-input-container><md-list class=\"all-day\"><md-list-item><p translate=\"CALENDAR.ALL_DAY\">All Day</p><md-switch \nclass=\"md-secondary\" ng-model=\"vm.calendarEvent.allday\" aria-label=\"All day\" translate \ntranslate-attr-aria-label=\"CALENDAR.ALL_DAY\"></md-switch></md-list-item></md-list><div layout=\"row\" class=\"date-row\">\n<md-datepicker ng-model=\"vm.calendarEvent.start\" md-placeholder=\"Start Date\"></md-datepicker><md-input-container \nclass=\"no-errors-spacer\" flex md-no-float><input ng-model=\"vm.calendarEvent.startTime\" placeholder=\"Start Time\" \ntranslate translate-attr-placeholder=\"CALENDAR.START_TIME\"></md-input-container></div><div layout=\"row\" \nclass=\"date-row\"><md-datepicker ng-model=\"vm.calendarEvent.end\" md-placeholder=\"End Date\"></md-datepicker>\n<md-input-container class=\"no-errors-spacer\" flex md-no-float><input ng-model=\"vm.calendarEvent.endTime\" \nplaceholder=\"End Time\" translate translate-attr-placeholder=\"CALENDAR.END_TIME\"></md-input-container></div>\n<md-input-container class=\"md-block\" flex><label translate=\"CALENDAR.REPEAT\">Repeat</label><input \nng-model=\"vm.calendarEvent.repeat\"></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"CALENDAR.LOCATION\">Location</label><input ng-model=\"vm.calendarEvent.location\"></md-input-container><div \nclass=\"notifications\" layout=\"column\"><div class=\"title\" translate=\"CALENDAR.NOTIFICATIONS\">Notifications</div>\n<md-select ng-model=\"notification\" placeholder=\"Notification\" \nng-repeat=\"notification in vm.calendarEvent.notifications\"><md-option ng-repeat=\"opt in vm.notifications\" \nvalue=\"{{opt}}\">{{opt}}</md-option></md-select><md-button aria-label=\"+ Add Another Notification\" \ntranslate=\"CALENDAR.ADD_NOTIFICATION\" translate-attr-aria-label=\"CALENDAR.ADD_NOTIFICATION\">+ Add Another Notification\n</md-button></div><md-input-container flex class=\"md-block textarea-container\"><label translate=\"CALENDAR.NOTES\">Notes\n</label><textarea ng-model=\"vm.task.notes\" md-maxlength=\"250\" max-rows=\"4\"></textarea></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button \nng-click=\"vm.saveEvent()\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\" translate=\"CALENDAR.SAVE\" \ntranslate-attr-aria-label=\"CALENDAR.SAVE\">SAVE</md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.removeEvent()\" aria-label=\"Delete\" translate translate-attr-aria-label=\"CALENDAR.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"CALENDAR.DELETE\">Delete</span></md-tooltip>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" layout=\"row\" layout-align=\"start center\"><div class=\"step\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">\nOptional</div></div></md-button><div class=\"ms-stepper-step-content\" ng-transclude></div><div \nclass=\"ms-stepper-controls\" layout=\"row\" layout-align=\"start center\" \nng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button class=\"md-accent md-raised\" \nng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);